/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DevRouteImport } from './routes/_dev'
import { Route as AppRouteImport } from './routes/_app'
import { Route as R404RouteImport } from './routes/404'
import { Route as R403RouteImport } from './routes/403'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BookingIndexRouteImport } from './routes/booking/index'
import { Route as ChonAnhTokenRouteImport } from './routes/chon-anh.$token'
import { Route as BookingMeRouteImport } from './routes/booking/me'
import { Route as BookingBranchCodeRouteImport } from './routes/booking/$branchCode'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AnhInTokenRouteImport } from './routes/anh-in.$token'
import { Route as AlbumTokenRouteImport } from './routes/album.$token'
import { Route as DevSalaryDetailRouteImport } from './routes/_dev.salary-detail'
import { Route as DevKpiScopeRouteImport } from './routes/_dev.kpi-scope'
import { Route as DevFaceProbeRouteImport } from './routes/_dev.face-probe'
import { Route as DevEkipProofRouteImport } from './routes/_dev.ekip-proof'
import { Route as DevCskhPreviewRouteImport } from './routes/_dev.cskh-preview'
import { Route as DevComponentsRouteImport } from './routes/_dev.components'
import { Route as DevAttentionRouteImport } from './routes/_dev.attention'
import { Route as AppTraDoRouteImport } from './routes/_app/tra-do'
import { Route as AppStoreBoardRouteImport } from './routes/_app/store-board'
import { Route as AppStaffProductivityRouteImport } from './routes/_app/staff-productivity'
import { Route as AppStaffCheckinsRouteImport } from './routes/_app/staff-checkins'
import { Route as AppStaffRouteImport } from './routes/_app/staff'
import { Route as AppSetBoardRouteImport } from './routes/_app/set-board'
import { Route as AppSealedInboxReaderRouteImport } from './routes/_app/sealed-inbox-reader'
import { Route as AppSealedInboxRouteImport } from './routes/_app/sealed-inbox'
import { Route as AppRetouchDispatchSettingsRouteImport } from './routes/_app/retouch-dispatch-settings'
import { Route as AppRegulationsRouteImport } from './routes/_app/regulations'
import { Route as AppQuoteApprovalsRouteImport } from './routes/_app/quote-approvals'
import { Route as AppProductsRouteImport } from './routes/_app/products'
import { Route as AppPrinterInvoicesRouteImport } from './routes/_app/printer-invoices'
import { Route as AppPrintOpsReportRouteImport } from './routes/_app/print-ops-report'
import { Route as AppPaymentsRouteImport } from './routes/_app/payments'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppMyDispatchRouteImport } from './routes/_app/my-dispatch'
import { Route as AppMedalsRouteImport } from './routes/_app/medals'
import { Route as AppMeRouteImport } from './routes/_app/me'
import { Route as AppKenhNhanSuRouteImport } from './routes/_app/kenh-nhan-su'
import { Route as AppIntegrationsRouteImport } from './routes/_app/integrations'
import { Route as AppHunchRoomRouteImport } from './routes/_app/hunch-room'
import { Route as AppHomeRouteImport } from './routes/_app.home'
import { Route as AppFraudBoardRouteImport } from './routes/_app/fraud-board'
import { Route as AppExpenseClaimsRouteImport } from './routes/_app/expense-claims'
import { Route as AppDispatchSettingsRouteImport } from './routes/_app/dispatch-settings'
import { Route as AppDispatchPointsRouteImport } from './routes/_app/dispatch-points'
import { Route as AppDispatchBoardRouteImport } from './routes/_app/dispatch-board'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppCustomerChatsRouteImport } from './routes/_app.customer-chats'
import { Route as AppCostumesRouteImport } from './routes/_app/costumes'
import { Route as AppComposeBackdropsRouteImport } from './routes/_app/compose-backdrops'
import { Route as AppZaloRouteRouteImport } from './routes/_app/zalo/route'
import { Route as AppViecCanXemRouteRouteImport } from './routes/_app/viec-can-xem/route'
import { Route as AppSuggestionsRouteRouteImport } from './routes/_app/suggestions/route'
import { Route as AppSpotChecksRouteRouteImport } from './routes/_app/spot-checks/route'
import { Route as AppScheduleRouteRouteImport } from './routes/_app/schedule/route'
import { Route as AppSalesTeamRouteRouteImport } from './routes/_app/sales-team/route'
import { Route as AppSalaryRulesV2RouteRouteImport } from './routes/_app/salary-rules-v2/route'
import { Route as AppSalaryRulesRouteRouteImport } from './routes/_app/salary-rules/route'
import { Route as AppSalaryAnalyticsRouteRouteImport } from './routes/_app/salary-analytics/route'
import { Route as AppRetouchRouteRouteImport } from './routes/_app/retouch/route'
import { Route as AppReportsRouteRouteImport } from './routes/_app/reports/route'
import { Route as AppRankingsRouteRouteImport } from './routes/_app/rankings/route'
import { Route as AppQualityRouteRouteImport } from './routes/_app/quality/route'
import { Route as AppQcOverviewRouteRouteImport } from './routes/_app/qc-overview/route'
import { Route as AppQcDeskRouteRouteImport } from './routes/_app/qc-desk/route'
import { Route as AppQcBoardRouteRouteImport } from './routes/_app/qc-board/route'
import { Route as AppPromosRouteRouteImport } from './routes/_app/promos/route'
import { Route as AppPrintOpsRouteRouteImport } from './routes/_app/print-ops/route'
import { Route as AppPhotoWorkRouteRouteImport } from './routes/_app/photo-work/route'
import { Route as AppPerformanceRouteRouteImport } from './routes/_app/performance/route'
import { Route as AppPayrollRouteRouteImport } from './routes/_app/payroll/route'
import { Route as AppOrdersRouteRouteImport } from './routes/_app/orders/route'
import { Route as AppObligationsRouteRouteImport } from './routes/_app/obligations/route'
import { Route as AppMgmtPerformanceRouteRouteImport } from './routes/_app/mgmt-performance/route'
import { Route as AppMarketingRouteRouteImport } from './routes/_app/marketing/route'
import { Route as AppLetanShiftsRouteRouteImport } from './routes/_app/letan-shifts/route'
import { Route as AppKhoYTuongRouteRouteImport } from './routes/_app/kho-y-tuong/route'
import { Route as AppKhoRouteRouteImport } from './routes/_app/kho/route'
import { Route as AppHalfDaySlotsRouteRouteImport } from './routes/_app/half-day-slots/route'
import { Route as AppGeneralSettingsRouteRouteImport } from './routes/_app/general-settings/route'
import { Route as AppExpensesRouteRouteImport } from './routes/_app/expenses/route'
import { Route as AppEquipmentOverdueRouteRouteImport } from './routes/_app/equipment-overdue/route'
import { Route as AppEkipShiftsRouteRouteImport } from './routes/_app/ekip-shifts/route'
import { Route as AppEkipPoolRouteRouteImport } from './routes/_app/ekip-pool/route'
import { Route as AppEkipConfigRouteRouteImport } from './routes/_app/ekip-config/route'
import { Route as AppDirectorBoardRouteRouteImport } from './routes/_app/director-board/route'
import { Route as AppCustomersRouteRouteImport } from './routes/_app/customers/route'
import { Route as AppCustomerVoiceRouteRouteImport } from './routes/_app/customer-voice/route'
import { Route as AppCskhRouteRouteImport } from './routes/_app/cskh/route'
import { Route as AppConceptGuidesRouteRouteImport } from './routes/_app/concept-guides/route'
import { Route as AppComplaintsRouteRouteImport } from './routes/_app/complaints/route'
import { Route as AppCashDrawerRouteRouteImport } from './routes/_app/cash-drawer/route'
import { Route as AppCashChainRouteRouteImport } from './routes/_app/cash-chain/route'
import { Route as AppBusinessPlanRouteRouteImport } from './routes/_app/business-plan/route'
import { Route as AppBranchShiftsRouteRouteImport } from './routes/_app/branch-shifts/route'
import { Route as AppBranchScoresRouteRouteImport } from './routes/_app/branch-scores/route'
import { Route as AppBranchKpiRouteRouteImport } from './routes/_app/branch-kpi/route'
import { Route as AppAlbumsRouteRouteImport } from './routes/_app/albums/route'
import { Route as AppAffiliatesRouteRouteImport } from './routes/_app/affiliates/route'
import { Route as AppZaloIndexRouteImport } from './routes/_app/zalo/index'
import { Route as AppViecCanXemIndexRouteImport } from './routes/_app/viec-can-xem/index'
import { Route as AppSuggestionsIndexRouteImport } from './routes/_app/suggestions/index'
import { Route as AppSpotChecksIndexRouteImport } from './routes/_app/spot-checks/index'
import { Route as AppScheduleIndexRouteImport } from './routes/_app/schedule/index'
import { Route as AppSalesTeamIndexRouteImport } from './routes/_app/sales-team/index'
import { Route as AppSalaryRulesIndexRouteImport } from './routes/_app/salary-rules/index'
import { Route as AppSalaryRulesV2IndexRouteImport } from './routes/_app/salary-rules-v2/index'
import { Route as AppSalaryAnalyticsIndexRouteImport } from './routes/_app/salary-analytics/index'
import { Route as AppRetouchIndexRouteImport } from './routes/_app/retouch/index'
import { Route as AppReportsIndexRouteImport } from './routes/_app/reports/index'
import { Route as AppRankingsIndexRouteImport } from './routes/_app/rankings/index'
import { Route as AppQualityIndexRouteImport } from './routes/_app/quality/index'
import { Route as AppQcOverviewIndexRouteImport } from './routes/_app/qc-overview/index'
import { Route as AppQcDeskIndexRouteImport } from './routes/_app/qc-desk/index'
import { Route as AppQcBoardIndexRouteImport } from './routes/_app/qc-board/index'
import { Route as AppPromosIndexRouteImport } from './routes/_app/promos/index'
import { Route as AppPrintOpsIndexRouteImport } from './routes/_app/print-ops/index'
import { Route as AppPhotoWorkIndexRouteImport } from './routes/_app/photo-work/index'
import { Route as AppPerformanceIndexRouteImport } from './routes/_app/performance/index'
import { Route as AppPayrollIndexRouteImport } from './routes/_app/payroll/index'
import { Route as AppOrdersIndexRouteImport } from './routes/_app/orders/index'
import { Route as AppObligationsIndexRouteImport } from './routes/_app/obligations/index'
import { Route as AppMgmtPerformanceIndexRouteImport } from './routes/_app/mgmt-performance/index'
import { Route as AppMarketingIndexRouteImport } from './routes/_app/marketing/index'
import { Route as AppLetanShiftsIndexRouteImport } from './routes/_app/letan-shifts/index'
import { Route as AppKhoIndexRouteImport } from './routes/_app/kho/index'
import { Route as AppKhoYTuongIndexRouteImport } from './routes/_app/kho-y-tuong/index'
import { Route as AppHalfDaySlotsIndexRouteImport } from './routes/_app/half-day-slots/index'
import { Route as AppGeneralSettingsIndexRouteImport } from './routes/_app/general-settings/index'
import { Route as AppExpensesIndexRouteImport } from './routes/_app/expenses/index'
import { Route as AppEquipmentOverdueIndexRouteImport } from './routes/_app/equipment-overdue/index'
import { Route as AppEkipShiftsIndexRouteImport } from './routes/_app/ekip-shifts/index'
import { Route as AppEkipPoolIndexRouteImport } from './routes/_app/ekip-pool/index'
import { Route as AppEkipConfigIndexRouteImport } from './routes/_app/ekip-config/index'
import { Route as AppDirectorBoardIndexRouteImport } from './routes/_app/director-board/index'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers/index'
import { Route as AppCustomerVoiceIndexRouteImport } from './routes/_app/customer-voice/index'
import { Route as AppCskhIndexRouteImport } from './routes/_app/cskh/index'
import { Route as AppComplaintsIndexRouteImport } from './routes/_app/complaints/index'
import { Route as AppCashDrawerIndexRouteImport } from './routes/_app/cash-drawer/index'
import { Route as AppCashChainIndexRouteImport } from './routes/_app/cash-chain/index'
import { Route as AppBusinessPlanIndexRouteImport } from './routes/_app/business-plan/index'
import { Route as AppBranchShiftsIndexRouteImport } from './routes/_app/branch-shifts/index'
import { Route as AppBranchScoresIndexRouteImport } from './routes/_app/branch-scores/index'
import { Route as AppBranchKpiIndexRouteImport } from './routes/_app/branch-kpi/index'
import { Route as AppAlbumsIndexRouteImport } from './routes/_app/albums/index'
import { Route as AppAffiliatesIndexRouteImport } from './routes/_app/affiliates/index'
import { Route as GalleryShareTokenRouteImport } from './routes/gallery.share.$token'
import { Route as AppSealedInboxIdRouteImport } from './routes/_app/sealed-inbox_.$id'
import { Route as AppSealedInboxReaderIdRouteImport } from './routes/_app/sealed-inbox-reader_.$id'
import { Route as AppSalaryAnalyticsStaffIdRouteImport } from './routes/_app/salary-analytics/$staffId'
import { Route as AppQuotePrintOrderIdRouteImport } from './routes/_app/quote-print.$orderId'
import { Route as AppQcDeskHauKiemRouteImport } from './routes/_app/qc-desk/hau-kiem'
import { Route as AppQcDeskHanhTrinhRouteImport } from './routes/_app/qc-desk/hanh-trinh'
import { Route as AppQcDeskAnhTheRouteImport } from './routes/_app/qc-desk/anh-the'
import { Route as AppPromosPromoIdRouteImport } from './routes/_app/promos/$promoId'
import { Route as AppPerformanceReviewRouteImport } from './routes/_app/performance/review'
import { Route as AppPerformanceAdminRouteImport } from './routes/_app/performance/admin'
import { Route as AppOrdersNewRouteImport } from './routes/_app/orders/new'
import { Route as AppOrdersOrderIdRouteImport } from './routes/_app/orders/$orderId'
import { Route as AppMeJourneyRouteImport } from './routes/_app/me_.journey'
import { Route as AppMeCollectionRouteImport } from './routes/_app/me_.collection'
import { Route as AppCustomersOrderHistoryRouteImport } from './routes/_app/customers/order-history'
import { Route as AppCustomersCustomerIdRouteImport } from './routes/_app/customers/$customerId'
import { Route as AppCskhOrderIdRouteImport } from './routes/_app/cskh/$orderId'
import { Route as AppAlbumsLedgerRouteImport } from './routes/_app/albums/ledger'
import { Route as AppRetouchOrdersOrderIdRouteImport } from './routes/_app/retouch/orders/$orderId'
import { Route as AppQcOverviewQcStaffIdRouteImport } from './routes/_app/qc-overview/qc.$staffId'
import { Route as AppGalleryAlbumsContainerIdRouteImport } from './routes/_app/gallery/albums/$containerId'
import { Route as AppFraudBoardKhachBiMatIdRouteImport } from './routes/_app/fraud-board_.khach-bi-mat.$id'
import { Route as AppFraudBoardCapSoKeyRouteImport } from './routes/_app/fraud-board_.cap-so.$key'
import { Route as AppFraudBoardCapNguoiKeyRouteImport } from './routes/_app/fraud-board_.cap-nguoi.$key'
import { Route as AppFraudBoardBangChungIdRouteImport } from './routes/_app/fraud-board_.bang-chung.$id'
import { Route as AppGalleryOrdersOrderIdRouteRouteImport } from './routes/_app/gallery/orders/$orderId/route'
import { Route as AppGalleryOrdersOrderIdIndexRouteImport } from './routes/_app/gallery/orders/$orderId/index'
import { Route as BookingMeOrdersOrderIdOriginalAlbumRouteImport } from './routes/booking.me_.orders.$orderId.original-album'
import { Route as BookingMeOrdersOrderIdGalleryRouteImport } from './routes/booking.me_.orders.$orderId.gallery'
import { Route as BookingMeOrdersOrderIdAlbumRouteImport } from './routes/booking.me_.orders.$orderId.album'
import { Route as AppGalleryOrdersOrderIdFixBoardRouteImport } from './routes/_app/gallery/orders/$orderId/fix-board'
import { Route as AppGalleryOrdersOrderIdComposeAlbumIdRouteImport } from './routes/_app/gallery/orders/$orderId/compose/$albumId'

const AppMuonTraDoLazyRouteImport = createFileRoute('/_app/muon-tra-do')()

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: '/_dev',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingIndexRoute = BookingIndexRouteImport.update({
  id: '/booking/',
  path: '/booking/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppMuonTraDoLazyRoute = AppMuonTraDoLazyRouteImport.update({
  id: '/muon-tra-do',
  path: '/muon-tra-do',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/muon-tra-do.lazy').then((d) => d.Route),
)
const ChonAnhTokenRoute = ChonAnhTokenRouteImport.update({
  id: '/chon-anh/$token',
  path: '/chon-anh/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingMeRoute = BookingMeRouteImport.update({
  id: '/booking/me',
  path: '/booking/me',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingBranchCodeRoute = BookingBranchCodeRouteImport.update({
  id: '/booking/$branchCode',
  path: '/booking/$branchCode',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AnhInTokenRoute = AnhInTokenRouteImport.update({
  id: '/anh-in/$token',
  path: '/anh-in/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AlbumTokenRoute = AlbumTokenRouteImport.update({
  id: '/album/$token',
  path: '/album/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DevSalaryDetailRoute = DevSalaryDetailRouteImport.update({
  id: '/salary-detail',
  path: '/salary-detail',
  getParentRoute: () => DevRoute,
} as any)
const DevKpiScopeRoute = DevKpiScopeRouteImport.update({
  id: '/kpi-scope',
  path: '/kpi-scope',
  getParentRoute: () => DevRoute,
} as any)
const DevFaceProbeRoute = DevFaceProbeRouteImport.update({
  id: '/face-probe',
  path: '/face-probe',
  getParentRoute: () => DevRoute,
} as any).lazy(() =>
  import('./routes/_dev.face-probe.lazy').then((d) => d.Route),
)
const DevEkipProofRoute = DevEkipProofRouteImport.update({
  id: '/ekip-proof',
  path: '/ekip-proof',
  getParentRoute: () => DevRoute,
} as any)
const DevCskhPreviewRoute = DevCskhPreviewRouteImport.update({
  id: '/cskh-preview',
  path: '/cskh-preview',
  getParentRoute: () => DevRoute,
} as any)
const DevComponentsRoute = DevComponentsRouteImport.update({
  id: '/components',
  path: '/components',
  getParentRoute: () => DevRoute,
} as any)
const DevAttentionRoute = DevAttentionRouteImport.update({
  id: '/attention',
  path: '/attention',
  getParentRoute: () => DevRoute,
} as any)
const AppTraDoRoute = AppTraDoRouteImport.update({
  id: '/tra-do',
  path: '/tra-do',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/tra-do.lazy').then((d) => d.Route))
const AppStoreBoardRoute = AppStoreBoardRouteImport.update({
  id: '/store-board',
  path: '/store-board',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/store-board.lazy').then((d) => d.Route),
)
const AppStaffProductivityRoute = AppStaffProductivityRouteImport.update({
  id: '/staff-productivity',
  path: '/staff-productivity',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/staff-productivity.lazy').then((d) => d.Route),
)
const AppStaffCheckinsRoute = AppStaffCheckinsRouteImport.update({
  id: '/staff-checkins',
  path: '/staff-checkins',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/staff-checkins.lazy').then((d) => d.Route),
)
const AppStaffRoute = AppStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/staff.lazy').then((d) => d.Route))
const AppSetBoardRoute = AppSetBoardRouteImport.update({
  id: '/set-board',
  path: '/set-board',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/set-board.lazy').then((d) => d.Route),
)
const AppSealedInboxReaderRoute = AppSealedInboxReaderRouteImport.update({
  id: '/sealed-inbox-reader',
  path: '/sealed-inbox-reader',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/sealed-inbox-reader.lazy').then((d) => d.Route),
)
const AppSealedInboxRoute = AppSealedInboxRouteImport.update({
  id: '/sealed-inbox',
  path: '/sealed-inbox',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/sealed-inbox.lazy').then((d) => d.Route),
)
const AppRetouchDispatchSettingsRoute =
  AppRetouchDispatchSettingsRouteImport.update({
    id: '/retouch-dispatch-settings',
    path: '/retouch-dispatch-settings',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/retouch-dispatch-settings.lazy').then((d) => d.Route),
  )
const AppRegulationsRoute = AppRegulationsRouteImport.update({
  id: '/regulations',
  path: '/regulations',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/regulations.lazy').then((d) => d.Route),
)
const AppQuoteApprovalsRoute = AppQuoteApprovalsRouteImport.update({
  id: '/quote-approvals',
  path: '/quote-approvals',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/quote-approvals.lazy').then((d) => d.Route),
)
const AppProductsRoute = AppProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/products.lazy').then((d) => d.Route))
const AppPrinterInvoicesRoute = AppPrinterInvoicesRouteImport.update({
  id: '/printer-invoices',
  path: '/printer-invoices',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/printer-invoices.lazy').then((d) => d.Route),
)
const AppPrintOpsReportRoute = AppPrintOpsReportRouteImport.update({
  id: '/print-ops-report',
  path: '/print-ops-report',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/print-ops-report.lazy').then((d) => d.Route),
)
const AppPaymentsRoute = AppPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/payments.lazy').then((d) => d.Route))
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/notifications.lazy').then((d) => d.Route),
)
const AppMyDispatchRoute = AppMyDispatchRouteImport.update({
  id: '/my-dispatch',
  path: '/my-dispatch',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/my-dispatch.lazy').then((d) => d.Route),
)
const AppMedalsRoute = AppMedalsRouteImport.update({
  id: '/medals',
  path: '/medals',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/medals.lazy').then((d) => d.Route))
const AppMeRoute = AppMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/me.lazy').then((d) => d.Route))
const AppKenhNhanSuRoute = AppKenhNhanSuRouteImport.update({
  id: '/kenh-nhan-su',
  path: '/kenh-nhan-su',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/kenh-nhan-su.lazy').then((d) => d.Route),
)
const AppIntegrationsRoute = AppIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/integrations.lazy').then((d) => d.Route),
)
const AppHunchRoomRoute = AppHunchRoomRouteImport.update({
  id: '/hunch-room',
  path: '/hunch-room',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/hunch-room.lazy').then((d) => d.Route),
)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppFraudBoardRoute = AppFraudBoardRouteImport.update({
  id: '/fraud-board',
  path: '/fraud-board',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/fraud-board.lazy').then((d) => d.Route),
)
const AppExpenseClaimsRoute = AppExpenseClaimsRouteImport.update({
  id: '/expense-claims',
  path: '/expense-claims',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/expense-claims.lazy').then((d) => d.Route),
)
const AppDispatchSettingsRoute = AppDispatchSettingsRouteImport.update({
  id: '/dispatch-settings',
  path: '/dispatch-settings',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/dispatch-settings.lazy').then((d) => d.Route),
)
const AppDispatchPointsRoute = AppDispatchPointsRouteImport.update({
  id: '/dispatch-points',
  path: '/dispatch-points',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/dispatch-points.lazy').then((d) => d.Route),
)
const AppDispatchBoardRoute = AppDispatchBoardRouteImport.update({
  id: '/dispatch-board',
  path: '/dispatch-board',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/dispatch-board.lazy').then((d) => d.Route),
)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app.dashboard.lazy').then((d) => d.Route),
)
const AppCustomerChatsRoute = AppCustomerChatsRouteImport.update({
  id: '/customer-chats',
  path: '/customer-chats',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app.customer-chats.lazy').then((d) => d.Route),
)
const AppCostumesRoute = AppCostumesRouteImport.update({
  id: '/costumes',
  path: '/costumes',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/costumes.lazy').then((d) => d.Route))
const AppComposeBackdropsRoute = AppComposeBackdropsRouteImport.update({
  id: '/compose-backdrops',
  path: '/compose-backdrops',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/compose-backdrops.lazy').then((d) => d.Route),
)
const AppZaloRouteRoute = AppZaloRouteRouteImport.update({
  id: '/zalo',
  path: '/zalo',
  getParentRoute: () => AppRoute,
} as any)
const AppViecCanXemRouteRoute = AppViecCanXemRouteRouteImport.update({
  id: '/viec-can-xem',
  path: '/viec-can-xem',
  getParentRoute: () => AppRoute,
} as any)
const AppSuggestionsRouteRoute = AppSuggestionsRouteRouteImport.update({
  id: '/suggestions',
  path: '/suggestions',
  getParentRoute: () => AppRoute,
} as any)
const AppSpotChecksRouteRoute = AppSpotChecksRouteRouteImport.update({
  id: '/spot-checks',
  path: '/spot-checks',
  getParentRoute: () => AppRoute,
} as any)
const AppScheduleRouteRoute = AppScheduleRouteRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesTeamRouteRoute = AppSalesTeamRouteRouteImport.update({
  id: '/sales-team',
  path: '/sales-team',
  getParentRoute: () => AppRoute,
} as any)
const AppSalaryRulesV2RouteRoute = AppSalaryRulesV2RouteRouteImport.update({
  id: '/salary-rules-v2',
  path: '/salary-rules-v2',
  getParentRoute: () => AppRoute,
} as any)
const AppSalaryRulesRouteRoute = AppSalaryRulesRouteRouteImport.update({
  id: '/salary-rules',
  path: '/salary-rules',
  getParentRoute: () => AppRoute,
} as any)
const AppSalaryAnalyticsRouteRoute = AppSalaryAnalyticsRouteRouteImport.update({
  id: '/salary-analytics',
  path: '/salary-analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppRetouchRouteRoute = AppRetouchRouteRouteImport.update({
  id: '/retouch',
  path: '/retouch',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRouteRoute = AppReportsRouteRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppRankingsRouteRoute = AppRankingsRouteRouteImport.update({
  id: '/rankings',
  path: '/rankings',
  getParentRoute: () => AppRoute,
} as any)
const AppQualityRouteRoute = AppQualityRouteRouteImport.update({
  id: '/quality',
  path: '/quality',
  getParentRoute: () => AppRoute,
} as any)
const AppQcOverviewRouteRoute = AppQcOverviewRouteRouteImport.update({
  id: '/qc-overview',
  path: '/qc-overview',
  getParentRoute: () => AppRoute,
} as any)
const AppQcDeskRouteRoute = AppQcDeskRouteRouteImport.update({
  id: '/qc-desk',
  path: '/qc-desk',
  getParentRoute: () => AppRoute,
} as any)
const AppQcBoardRouteRoute = AppQcBoardRouteRouteImport.update({
  id: '/qc-board',
  path: '/qc-board',
  getParentRoute: () => AppRoute,
} as any)
const AppPromosRouteRoute = AppPromosRouteRouteImport.update({
  id: '/promos',
  path: '/promos',
  getParentRoute: () => AppRoute,
} as any)
const AppPrintOpsRouteRoute = AppPrintOpsRouteRouteImport.update({
  id: '/print-ops',
  path: '/print-ops',
  getParentRoute: () => AppRoute,
} as any)
const AppPhotoWorkRouteRoute = AppPhotoWorkRouteRouteImport.update({
  id: '/photo-work',
  path: '/photo-work',
  getParentRoute: () => AppRoute,
} as any)
const AppPerformanceRouteRoute = AppPerformanceRouteRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => AppRoute,
} as any)
const AppPayrollRouteRoute = AppPayrollRouteRouteImport.update({
  id: '/payroll',
  path: '/payroll',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersRouteRoute = AppOrdersRouteRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppObligationsRouteRoute = AppObligationsRouteRouteImport.update({
  id: '/obligations',
  path: '/obligations',
  getParentRoute: () => AppRoute,
} as any)
const AppMgmtPerformanceRouteRoute = AppMgmtPerformanceRouteRouteImport.update({
  id: '/mgmt-performance',
  path: '/mgmt-performance',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketingRouteRoute = AppMarketingRouteRouteImport.update({
  id: '/marketing',
  path: '/marketing',
  getParentRoute: () => AppRoute,
} as any)
const AppLetanShiftsRouteRoute = AppLetanShiftsRouteRouteImport.update({
  id: '/letan-shifts',
  path: '/letan-shifts',
  getParentRoute: () => AppRoute,
} as any)
const AppKhoYTuongRouteRoute = AppKhoYTuongRouteRouteImport.update({
  id: '/kho-y-tuong',
  path: '/kho-y-tuong',
  getParentRoute: () => AppRoute,
} as any)
const AppKhoRouteRoute = AppKhoRouteRouteImport.update({
  id: '/kho',
  path: '/kho',
  getParentRoute: () => AppRoute,
} as any)
const AppHalfDaySlotsRouteRoute = AppHalfDaySlotsRouteRouteImport.update({
  id: '/half-day-slots',
  path: '/half-day-slots',
  getParentRoute: () => AppRoute,
} as any)
const AppGeneralSettingsRouteRoute = AppGeneralSettingsRouteRouteImport.update({
  id: '/general-settings',
  path: '/general-settings',
  getParentRoute: () => AppRoute,
} as any)
const AppExpensesRouteRoute = AppExpensesRouteRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => AppRoute,
} as any)
const AppEquipmentOverdueRouteRoute =
  AppEquipmentOverdueRouteRouteImport.update({
    id: '/equipment-overdue',
    path: '/equipment-overdue',
    getParentRoute: () => AppRoute,
  } as any)
const AppEkipShiftsRouteRoute = AppEkipShiftsRouteRouteImport.update({
  id: '/ekip-shifts',
  path: '/ekip-shifts',
  getParentRoute: () => AppRoute,
} as any)
const AppEkipPoolRouteRoute = AppEkipPoolRouteRouteImport.update({
  id: '/ekip-pool',
  path: '/ekip-pool',
  getParentRoute: () => AppRoute,
} as any)
const AppEkipConfigRouteRoute = AppEkipConfigRouteRouteImport.update({
  id: '/ekip-config',
  path: '/ekip-config',
  getParentRoute: () => AppRoute,
} as any)
const AppDirectorBoardRouteRoute = AppDirectorBoardRouteRouteImport.update({
  id: '/director-board',
  path: '/director-board',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersRouteRoute = AppCustomersRouteRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomerVoiceRouteRoute = AppCustomerVoiceRouteRouteImport.update({
  id: '/customer-voice',
  path: '/customer-voice',
  getParentRoute: () => AppRoute,
} as any)
const AppCskhRouteRoute = AppCskhRouteRouteImport.update({
  id: '/cskh',
  path: '/cskh',
  getParentRoute: () => AppRoute,
} as any)
const AppConceptGuidesRouteRoute = AppConceptGuidesRouteRouteImport.update({
  id: '/concept-guides',
  path: '/concept-guides',
  getParentRoute: () => AppRoute,
} as any)
const AppComplaintsRouteRoute = AppComplaintsRouteRouteImport.update({
  id: '/complaints',
  path: '/complaints',
  getParentRoute: () => AppRoute,
} as any)
const AppCashDrawerRouteRoute = AppCashDrawerRouteRouteImport.update({
  id: '/cash-drawer',
  path: '/cash-drawer',
  getParentRoute: () => AppRoute,
} as any)
const AppCashChainRouteRoute = AppCashChainRouteRouteImport.update({
  id: '/cash-chain',
  path: '/cash-chain',
  getParentRoute: () => AppRoute,
} as any)
const AppBusinessPlanRouteRoute = AppBusinessPlanRouteRouteImport.update({
  id: '/business-plan',
  path: '/business-plan',
  getParentRoute: () => AppRoute,
} as any)
const AppBranchShiftsRouteRoute = AppBranchShiftsRouteRouteImport.update({
  id: '/branch-shifts',
  path: '/branch-shifts',
  getParentRoute: () => AppRoute,
} as any)
const AppBranchScoresRouteRoute = AppBranchScoresRouteRouteImport.update({
  id: '/branch-scores',
  path: '/branch-scores',
  getParentRoute: () => AppRoute,
} as any)
const AppBranchKpiRouteRoute = AppBranchKpiRouteRouteImport.update({
  id: '/branch-kpi',
  path: '/branch-kpi',
  getParentRoute: () => AppRoute,
} as any)
const AppAlbumsRouteRoute = AppAlbumsRouteRouteImport.update({
  id: '/albums',
  path: '/albums',
  getParentRoute: () => AppRoute,
} as any)
const AppAffiliatesRouteRoute = AppAffiliatesRouteRouteImport.update({
  id: '/affiliates',
  path: '/affiliates',
  getParentRoute: () => AppRoute,
} as any)
const AppZaloIndexRoute = AppZaloIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppZaloRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/zalo/index.lazy').then((d) => d.Route),
)
const AppViecCanXemIndexRoute = AppViecCanXemIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppViecCanXemRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/viec-can-xem/index.lazy').then((d) => d.Route),
)
const AppSuggestionsIndexRoute = AppSuggestionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSuggestionsRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/suggestions/index.lazy').then((d) => d.Route),
)
const AppSpotChecksIndexRoute = AppSpotChecksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSpotChecksRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/spot-checks/index.lazy').then((d) => d.Route),
)
const AppScheduleIndexRoute = AppScheduleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppScheduleRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/schedule/index.lazy').then((d) => d.Route),
)
const AppSalesTeamIndexRoute = AppSalesTeamIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSalesTeamRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/sales-team/index.lazy').then((d) => d.Route),
)
const AppSalaryRulesIndexRoute = AppSalaryRulesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSalaryRulesRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/salary-rules/index.lazy').then((d) => d.Route),
)
const AppSalaryRulesV2IndexRoute = AppSalaryRulesV2IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSalaryRulesV2RouteRoute,
} as any).lazy(() =>
  import('./routes/_app/salary-rules-v2/index.lazy').then((d) => d.Route),
)
const AppSalaryAnalyticsIndexRoute = AppSalaryAnalyticsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSalaryAnalyticsRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/salary-analytics/index.lazy').then((d) => d.Route),
)
const AppRetouchIndexRoute = AppRetouchIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRetouchRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/retouch/index.lazy').then((d) => d.Route),
)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppReportsRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/reports/index.lazy').then((d) => d.Route),
)
const AppRankingsIndexRoute = AppRankingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRankingsRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/rankings/index.lazy').then((d) => d.Route),
)
const AppQualityIndexRoute = AppQualityIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppQualityRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/quality/index.lazy').then((d) => d.Route),
)
const AppQcOverviewIndexRoute = AppQcOverviewIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppQcOverviewRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/qc-overview/index.lazy').then((d) => d.Route),
)
const AppQcDeskIndexRoute = AppQcDeskIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppQcDeskRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/qc-desk/index.lazy').then((d) => d.Route),
)
const AppQcBoardIndexRoute = AppQcBoardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppQcBoardRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/qc-board/index.lazy').then((d) => d.Route),
)
const AppPromosIndexRoute = AppPromosIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPromosRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/promos/index.lazy').then((d) => d.Route),
)
const AppPrintOpsIndexRoute = AppPrintOpsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPrintOpsRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/print-ops/index.lazy').then((d) => d.Route),
)
const AppPhotoWorkIndexRoute = AppPhotoWorkIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPhotoWorkRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/photo-work/index.lazy').then((d) => d.Route),
)
const AppPerformanceIndexRoute = AppPerformanceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPerformanceRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/performance/index.lazy').then((d) => d.Route),
)
const AppPayrollIndexRoute = AppPayrollIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPayrollRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/payroll/index.lazy').then((d) => d.Route),
)
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrdersRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/orders/index.lazy').then((d) => d.Route),
)
const AppObligationsIndexRoute = AppObligationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppObligationsRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/obligations/index.lazy').then((d) => d.Route),
)
const AppMgmtPerformanceIndexRoute = AppMgmtPerformanceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMgmtPerformanceRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/mgmt-performance/index.lazy').then((d) => d.Route),
)
const AppMarketingIndexRoute = AppMarketingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMarketingRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/marketing/index.lazy').then((d) => d.Route),
)
const AppLetanShiftsIndexRoute = AppLetanShiftsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLetanShiftsRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/letan-shifts/index.lazy').then((d) => d.Route),
)
const AppKhoIndexRoute = AppKhoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppKhoRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/kho/index.lazy').then((d) => d.Route),
)
const AppKhoYTuongIndexRoute = AppKhoYTuongIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppKhoYTuongRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/kho-y-tuong/index.lazy').then((d) => d.Route),
)
const AppHalfDaySlotsIndexRoute = AppHalfDaySlotsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppHalfDaySlotsRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/half-day-slots/index.lazy').then((d) => d.Route),
)
const AppGeneralSettingsIndexRoute = AppGeneralSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppGeneralSettingsRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/general-settings/index.lazy').then((d) => d.Route),
)
const AppExpensesIndexRoute = AppExpensesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppExpensesRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/expenses/index.lazy').then((d) => d.Route),
)
const AppEquipmentOverdueIndexRoute =
  AppEquipmentOverdueIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppEquipmentOverdueRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/equipment-overdue/index.lazy').then((d) => d.Route),
  )
const AppEkipShiftsIndexRoute = AppEkipShiftsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppEkipShiftsRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/ekip-shifts/index.lazy').then((d) => d.Route),
)
const AppEkipPoolIndexRoute = AppEkipPoolIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppEkipPoolRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/ekip-pool/index.lazy').then((d) => d.Route),
)
const AppEkipConfigIndexRoute = AppEkipConfigIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppEkipConfigRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/ekip-config/index.lazy').then((d) => d.Route),
)
const AppDirectorBoardIndexRoute = AppDirectorBoardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDirectorBoardRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/director-board/index.lazy').then((d) => d.Route),
)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCustomersRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/customers/index.lazy').then((d) => d.Route),
)
const AppCustomerVoiceIndexRoute = AppCustomerVoiceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCustomerVoiceRouteRoute,
} as any)
const AppCskhIndexRoute = AppCskhIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCskhRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/cskh/index.lazy').then((d) => d.Route),
)
const AppComplaintsIndexRoute = AppComplaintsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppComplaintsRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/complaints/index.lazy').then((d) => d.Route),
)
const AppCashDrawerIndexRoute = AppCashDrawerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCashDrawerRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/cash-drawer/index.lazy').then((d) => d.Route),
)
const AppCashChainIndexRoute = AppCashChainIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCashChainRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/cash-chain/index.lazy').then((d) => d.Route),
)
const AppBusinessPlanIndexRoute = AppBusinessPlanIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBusinessPlanRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/business-plan/index.lazy').then((d) => d.Route),
)
const AppBranchShiftsIndexRoute = AppBranchShiftsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBranchShiftsRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/branch-shifts/index.lazy').then((d) => d.Route),
)
const AppBranchScoresIndexRoute = AppBranchScoresIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBranchScoresRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/branch-scores/index.lazy').then((d) => d.Route),
)
const AppBranchKpiIndexRoute = AppBranchKpiIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBranchKpiRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/branch-kpi/index.lazy').then((d) => d.Route),
)
const AppAlbumsIndexRoute = AppAlbumsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAlbumsRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/albums/index.lazy').then((d) => d.Route),
)
const AppAffiliatesIndexRoute = AppAffiliatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAffiliatesRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/affiliates/index.lazy').then((d) => d.Route),
)
const GalleryShareTokenRoute = GalleryShareTokenRouteImport.update({
  id: '/gallery/share/$token',
  path: '/gallery/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSealedInboxIdRoute = AppSealedInboxIdRouteImport.update({
  id: '/sealed-inbox_/$id',
  path: '/sealed-inbox/$id',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/sealed-inbox_.$id.lazy').then((d) => d.Route),
)
const AppSealedInboxReaderIdRoute = AppSealedInboxReaderIdRouteImport.update({
  id: '/sealed-inbox-reader_/$id',
  path: '/sealed-inbox-reader/$id',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/sealed-inbox-reader_.$id.lazy').then((d) => d.Route),
)
const AppSalaryAnalyticsStaffIdRoute =
  AppSalaryAnalyticsStaffIdRouteImport.update({
    id: '/$staffId',
    path: '/$staffId',
    getParentRoute: () => AppSalaryAnalyticsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/salary-analytics/$staffId.lazy').then((d) => d.Route),
  )
const AppQuotePrintOrderIdRoute = AppQuotePrintOrderIdRouteImport.update({
  id: '/quote-print/$orderId',
  path: '/quote-print/$orderId',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/quote-print.$orderId.lazy').then((d) => d.Route),
)
const AppQcDeskHauKiemRoute = AppQcDeskHauKiemRouteImport.update({
  id: '/hau-kiem',
  path: '/hau-kiem',
  getParentRoute: () => AppQcDeskRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/qc-desk/hau-kiem.lazy').then((d) => d.Route),
)
const AppQcDeskHanhTrinhRoute = AppQcDeskHanhTrinhRouteImport.update({
  id: '/hanh-trinh',
  path: '/hanh-trinh',
  getParentRoute: () => AppQcDeskRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/qc-desk/hanh-trinh.lazy').then((d) => d.Route),
)
const AppQcDeskAnhTheRoute = AppQcDeskAnhTheRouteImport.update({
  id: '/anh-the',
  path: '/anh-the',
  getParentRoute: () => AppQcDeskRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/qc-desk/anh-the.lazy').then((d) => d.Route),
)
const AppPromosPromoIdRoute = AppPromosPromoIdRouteImport.update({
  id: '/$promoId',
  path: '/$promoId',
  getParentRoute: () => AppPromosRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/promos/$promoId.lazy').then((d) => d.Route),
)
const AppPerformanceReviewRoute = AppPerformanceReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AppPerformanceRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/performance/review.lazy').then((d) => d.Route),
)
const AppPerformanceAdminRoute = AppPerformanceAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppPerformanceRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/performance/admin.lazy').then((d) => d.Route),
)
const AppOrdersNewRoute = AppOrdersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppOrdersRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/orders/new.lazy').then((d) => d.Route),
)
const AppOrdersOrderIdRoute = AppOrdersOrderIdRouteImport.update({
  id: '/$orderId',
  path: '/$orderId',
  getParentRoute: () => AppOrdersRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/orders/$orderId.lazy').then((d) => d.Route),
)
const AppMeJourneyRoute = AppMeJourneyRouteImport.update({
  id: '/me_/journey',
  path: '/me/journey',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/me_.journey.lazy').then((d) => d.Route),
)
const AppMeCollectionRoute = AppMeCollectionRouteImport.update({
  id: '/me_/collection',
  path: '/me/collection',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/me_.collection.lazy').then((d) => d.Route),
)
const AppCustomersOrderHistoryRoute =
  AppCustomersOrderHistoryRouteImport.update({
    id: '/order-history',
    path: '/order-history',
    getParentRoute: () => AppCustomersRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/customers/order-history.lazy').then((d) => d.Route),
  )
const AppCustomersCustomerIdRoute = AppCustomersCustomerIdRouteImport.update({
  id: '/$customerId',
  path: '/$customerId',
  getParentRoute: () => AppCustomersRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/customers/$customerId.lazy').then((d) => d.Route),
)
const AppCskhOrderIdRoute = AppCskhOrderIdRouteImport.update({
  id: '/$orderId',
  path: '/$orderId',
  getParentRoute: () => AppCskhRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/cskh/$orderId.lazy').then((d) => d.Route),
)
const AppAlbumsLedgerRoute = AppAlbumsLedgerRouteImport.update({
  id: '/ledger',
  path: '/ledger',
  getParentRoute: () => AppAlbumsRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/albums/ledger.lazy').then((d) => d.Route),
)
const AppRetouchOrdersOrderIdRoute = AppRetouchOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => AppRetouchRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/retouch/orders/$orderId.lazy').then((d) => d.Route),
)
const AppQcOverviewQcStaffIdRoute = AppQcOverviewQcStaffIdRouteImport.update({
  id: '/qc/$staffId',
  path: '/qc/$staffId',
  getParentRoute: () => AppQcOverviewRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/qc-overview/qc.$staffId.lazy').then((d) => d.Route),
)
const AppGalleryAlbumsContainerIdRoute =
  AppGalleryAlbumsContainerIdRouteImport.update({
    id: '/gallery/albums/$containerId',
    path: '/gallery/albums/$containerId',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/gallery/albums/$containerId.lazy').then(
      (d) => d.Route,
    ),
  )
const AppFraudBoardKhachBiMatIdRoute =
  AppFraudBoardKhachBiMatIdRouteImport.update({
    id: '/fraud-board_/khach-bi-mat/$id',
    path: '/fraud-board/khach-bi-mat/$id',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/fraud-board_.khach-bi-mat.$id.lazy').then(
      (d) => d.Route,
    ),
  )
const AppFraudBoardCapSoKeyRoute = AppFraudBoardCapSoKeyRouteImport.update({
  id: '/fraud-board_/cap-so/$key',
  path: '/fraud-board/cap-so/$key',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/fraud-board_.cap-so.$key.lazy').then((d) => d.Route),
)
const AppFraudBoardCapNguoiKeyRoute =
  AppFraudBoardCapNguoiKeyRouteImport.update({
    id: '/fraud-board_/cap-nguoi/$key',
    path: '/fraud-board/cap-nguoi/$key',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/fraud-board_.cap-nguoi.$key.lazy').then(
      (d) => d.Route,
    ),
  )
const AppFraudBoardBangChungIdRoute =
  AppFraudBoardBangChungIdRouteImport.update({
    id: '/fraud-board_/bang-chung/$id',
    path: '/fraud-board/bang-chung/$id',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/fraud-board_.bang-chung.$id.lazy').then(
      (d) => d.Route,
    ),
  )
const AppGalleryOrdersOrderIdRouteRoute =
  AppGalleryOrdersOrderIdRouteRouteImport.update({
    id: '/gallery/orders/$orderId',
    path: '/gallery/orders/$orderId',
    getParentRoute: () => AppRoute,
  } as any)
const AppGalleryOrdersOrderIdIndexRoute =
  AppGalleryOrdersOrderIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppGalleryOrdersOrderIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/gallery/orders/$orderId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const BookingMeOrdersOrderIdOriginalAlbumRoute =
  BookingMeOrdersOrderIdOriginalAlbumRouteImport.update({
    id: '/booking/me_/orders/$orderId/original-album',
    path: '/booking/me/orders/$orderId/original-album',
    getParentRoute: () => rootRouteImport,
  } as any)
const BookingMeOrdersOrderIdGalleryRoute =
  BookingMeOrdersOrderIdGalleryRouteImport.update({
    id: '/booking/me_/orders/$orderId/gallery',
    path: '/booking/me/orders/$orderId/gallery',
    getParentRoute: () => rootRouteImport,
  } as any)
const BookingMeOrdersOrderIdAlbumRoute =
  BookingMeOrdersOrderIdAlbumRouteImport.update({
    id: '/booking/me_/orders/$orderId/album',
    path: '/booking/me/orders/$orderId/album',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppGalleryOrdersOrderIdFixBoardRoute =
  AppGalleryOrdersOrderIdFixBoardRouteImport.update({
    id: '/fix-board',
    path: '/fix-board',
    getParentRoute: () => AppGalleryOrdersOrderIdRouteRoute,
  } as any)
const AppGalleryOrdersOrderIdComposeAlbumIdRoute =
  AppGalleryOrdersOrderIdComposeAlbumIdRouteImport.update({
    id: '/compose/$albumId',
    path: '/compose/$albumId',
    getParentRoute: () => AppGalleryOrdersOrderIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/gallery/orders/$orderId/compose/$albumId.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/login': typeof LoginRoute
  '/affiliates': typeof AppAffiliatesRouteRouteWithChildren
  '/albums': typeof AppAlbumsRouteRouteWithChildren
  '/branch-kpi': typeof AppBranchKpiRouteRouteWithChildren
  '/branch-scores': typeof AppBranchScoresRouteRouteWithChildren
  '/branch-shifts': typeof AppBranchShiftsRouteRouteWithChildren
  '/business-plan': typeof AppBusinessPlanRouteRouteWithChildren
  '/cash-chain': typeof AppCashChainRouteRouteWithChildren
  '/cash-drawer': typeof AppCashDrawerRouteRouteWithChildren
  '/complaints': typeof AppComplaintsRouteRouteWithChildren
  '/concept-guides': typeof AppConceptGuidesRouteRoute
  '/cskh': typeof AppCskhRouteRouteWithChildren
  '/customer-voice': typeof AppCustomerVoiceRouteRouteWithChildren
  '/customers': typeof AppCustomersRouteRouteWithChildren
  '/director-board': typeof AppDirectorBoardRouteRouteWithChildren
  '/ekip-config': typeof AppEkipConfigRouteRouteWithChildren
  '/ekip-pool': typeof AppEkipPoolRouteRouteWithChildren
  '/ekip-shifts': typeof AppEkipShiftsRouteRouteWithChildren
  '/equipment-overdue': typeof AppEquipmentOverdueRouteRouteWithChildren
  '/expenses': typeof AppExpensesRouteRouteWithChildren
  '/general-settings': typeof AppGeneralSettingsRouteRouteWithChildren
  '/half-day-slots': typeof AppHalfDaySlotsRouteRouteWithChildren
  '/kho': typeof AppKhoRouteRouteWithChildren
  '/kho-y-tuong': typeof AppKhoYTuongRouteRouteWithChildren
  '/letan-shifts': typeof AppLetanShiftsRouteRouteWithChildren
  '/marketing': typeof AppMarketingRouteRouteWithChildren
  '/mgmt-performance': typeof AppMgmtPerformanceRouteRouteWithChildren
  '/obligations': typeof AppObligationsRouteRouteWithChildren
  '/orders': typeof AppOrdersRouteRouteWithChildren
  '/payroll': typeof AppPayrollRouteRouteWithChildren
  '/performance': typeof AppPerformanceRouteRouteWithChildren
  '/photo-work': typeof AppPhotoWorkRouteRouteWithChildren
  '/print-ops': typeof AppPrintOpsRouteRouteWithChildren
  '/promos': typeof AppPromosRouteRouteWithChildren
  '/qc-board': typeof AppQcBoardRouteRouteWithChildren
  '/qc-desk': typeof AppQcDeskRouteRouteWithChildren
  '/qc-overview': typeof AppQcOverviewRouteRouteWithChildren
  '/quality': typeof AppQualityRouteRouteWithChildren
  '/rankings': typeof AppRankingsRouteRouteWithChildren
  '/reports': typeof AppReportsRouteRouteWithChildren
  '/retouch': typeof AppRetouchRouteRouteWithChildren
  '/salary-analytics': typeof AppSalaryAnalyticsRouteRouteWithChildren
  '/salary-rules': typeof AppSalaryRulesRouteRouteWithChildren
  '/salary-rules-v2': typeof AppSalaryRulesV2RouteRouteWithChildren
  '/sales-team': typeof AppSalesTeamRouteRouteWithChildren
  '/schedule': typeof AppScheduleRouteRouteWithChildren
  '/spot-checks': typeof AppSpotChecksRouteRouteWithChildren
  '/suggestions': typeof AppSuggestionsRouteRouteWithChildren
  '/viec-can-xem': typeof AppViecCanXemRouteRouteWithChildren
  '/zalo': typeof AppZaloRouteRouteWithChildren
  '/compose-backdrops': typeof AppComposeBackdropsRoute
  '/costumes': typeof AppCostumesRoute
  '/customer-chats': typeof AppCustomerChatsRoute
  '/dashboard': typeof AppDashboardRoute
  '/dispatch-board': typeof AppDispatchBoardRoute
  '/dispatch-points': typeof AppDispatchPointsRoute
  '/dispatch-settings': typeof AppDispatchSettingsRoute
  '/expense-claims': typeof AppExpenseClaimsRoute
  '/fraud-board': typeof AppFraudBoardRoute
  '/home': typeof AppHomeRoute
  '/hunch-room': typeof AppHunchRoomRoute
  '/integrations': typeof AppIntegrationsRoute
  '/kenh-nhan-su': typeof AppKenhNhanSuRoute
  '/me': typeof AppMeRoute
  '/medals': typeof AppMedalsRoute
  '/my-dispatch': typeof AppMyDispatchRoute
  '/notifications': typeof AppNotificationsRoute
  '/payments': typeof AppPaymentsRoute
  '/print-ops-report': typeof AppPrintOpsReportRoute
  '/printer-invoices': typeof AppPrinterInvoicesRoute
  '/products': typeof AppProductsRoute
  '/quote-approvals': typeof AppQuoteApprovalsRoute
  '/regulations': typeof AppRegulationsRoute
  '/retouch-dispatch-settings': typeof AppRetouchDispatchSettingsRoute
  '/sealed-inbox': typeof AppSealedInboxRoute
  '/sealed-inbox-reader': typeof AppSealedInboxReaderRoute
  '/set-board': typeof AppSetBoardRoute
  '/staff': typeof AppStaffRoute
  '/staff-checkins': typeof AppStaffCheckinsRoute
  '/staff-productivity': typeof AppStaffProductivityRoute
  '/store-board': typeof AppStoreBoardRoute
  '/tra-do': typeof AppTraDoRoute
  '/attention': typeof DevAttentionRoute
  '/components': typeof DevComponentsRoute
  '/cskh-preview': typeof DevCskhPreviewRoute
  '/ekip-proof': typeof DevEkipProofRoute
  '/face-probe': typeof DevFaceProbeRoute
  '/kpi-scope': typeof DevKpiScopeRoute
  '/salary-detail': typeof DevSalaryDetailRoute
  '/album/$token': typeof AlbumTokenRoute
  '/anh-in/$token': typeof AnhInTokenRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/booking/$branchCode': typeof BookingBranchCodeRoute
  '/booking/me': typeof BookingMeRoute
  '/chon-anh/$token': typeof ChonAnhTokenRoute
  '/muon-tra-do': typeof AppMuonTraDoLazyRoute
  '/booking/': typeof BookingIndexRoute
  '/albums/ledger': typeof AppAlbumsLedgerRoute
  '/cskh/$orderId': typeof AppCskhOrderIdRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/customers/order-history': typeof AppCustomersOrderHistoryRoute
  '/me/collection': typeof AppMeCollectionRoute
  '/me/journey': typeof AppMeJourneyRoute
  '/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/orders/new': typeof AppOrdersNewRoute
  '/performance/admin': typeof AppPerformanceAdminRoute
  '/performance/review': typeof AppPerformanceReviewRoute
  '/promos/$promoId': typeof AppPromosPromoIdRoute
  '/qc-desk/anh-the': typeof AppQcDeskAnhTheRoute
  '/qc-desk/hanh-trinh': typeof AppQcDeskHanhTrinhRoute
  '/qc-desk/hau-kiem': typeof AppQcDeskHauKiemRoute
  '/quote-print/$orderId': typeof AppQuotePrintOrderIdRoute
  '/salary-analytics/$staffId': typeof AppSalaryAnalyticsStaffIdRoute
  '/sealed-inbox-reader/$id': typeof AppSealedInboxReaderIdRoute
  '/sealed-inbox/$id': typeof AppSealedInboxIdRoute
  '/gallery/share/$token': typeof GalleryShareTokenRoute
  '/affiliates/': typeof AppAffiliatesIndexRoute
  '/albums/': typeof AppAlbumsIndexRoute
  '/branch-kpi/': typeof AppBranchKpiIndexRoute
  '/branch-scores/': typeof AppBranchScoresIndexRoute
  '/branch-shifts/': typeof AppBranchShiftsIndexRoute
  '/business-plan/': typeof AppBusinessPlanIndexRoute
  '/cash-chain/': typeof AppCashChainIndexRoute
  '/cash-drawer/': typeof AppCashDrawerIndexRoute
  '/complaints/': typeof AppComplaintsIndexRoute
  '/cskh/': typeof AppCskhIndexRoute
  '/customer-voice/': typeof AppCustomerVoiceIndexRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/director-board/': typeof AppDirectorBoardIndexRoute
  '/ekip-config/': typeof AppEkipConfigIndexRoute
  '/ekip-pool/': typeof AppEkipPoolIndexRoute
  '/ekip-shifts/': typeof AppEkipShiftsIndexRoute
  '/equipment-overdue/': typeof AppEquipmentOverdueIndexRoute
  '/expenses/': typeof AppExpensesIndexRoute
  '/general-settings/': typeof AppGeneralSettingsIndexRoute
  '/half-day-slots/': typeof AppHalfDaySlotsIndexRoute
  '/kho-y-tuong/': typeof AppKhoYTuongIndexRoute
  '/kho/': typeof AppKhoIndexRoute
  '/letan-shifts/': typeof AppLetanShiftsIndexRoute
  '/marketing/': typeof AppMarketingIndexRoute
  '/mgmt-performance/': typeof AppMgmtPerformanceIndexRoute
  '/obligations/': typeof AppObligationsIndexRoute
  '/orders/': typeof AppOrdersIndexRoute
  '/payroll/': typeof AppPayrollIndexRoute
  '/performance/': typeof AppPerformanceIndexRoute
  '/photo-work/': typeof AppPhotoWorkIndexRoute
  '/print-ops/': typeof AppPrintOpsIndexRoute
  '/promos/': typeof AppPromosIndexRoute
  '/qc-board/': typeof AppQcBoardIndexRoute
  '/qc-desk/': typeof AppQcDeskIndexRoute
  '/qc-overview/': typeof AppQcOverviewIndexRoute
  '/quality/': typeof AppQualityIndexRoute
  '/rankings/': typeof AppRankingsIndexRoute
  '/reports/': typeof AppReportsIndexRoute
  '/retouch/': typeof AppRetouchIndexRoute
  '/salary-analytics/': typeof AppSalaryAnalyticsIndexRoute
  '/salary-rules-v2/': typeof AppSalaryRulesV2IndexRoute
  '/salary-rules/': typeof AppSalaryRulesIndexRoute
  '/sales-team/': typeof AppSalesTeamIndexRoute
  '/schedule/': typeof AppScheduleIndexRoute
  '/spot-checks/': typeof AppSpotChecksIndexRoute
  '/suggestions/': typeof AppSuggestionsIndexRoute
  '/viec-can-xem/': typeof AppViecCanXemIndexRoute
  '/zalo/': typeof AppZaloIndexRoute
  '/gallery/orders/$orderId': typeof AppGalleryOrdersOrderIdRouteRouteWithChildren
  '/fraud-board/bang-chung/$id': typeof AppFraudBoardBangChungIdRoute
  '/fraud-board/cap-nguoi/$key': typeof AppFraudBoardCapNguoiKeyRoute
  '/fraud-board/cap-so/$key': typeof AppFraudBoardCapSoKeyRoute
  '/fraud-board/khach-bi-mat/$id': typeof AppFraudBoardKhachBiMatIdRoute
  '/gallery/albums/$containerId': typeof AppGalleryAlbumsContainerIdRoute
  '/qc-overview/qc/$staffId': typeof AppQcOverviewQcStaffIdRoute
  '/retouch/orders/$orderId': typeof AppRetouchOrdersOrderIdRoute
  '/gallery/orders/$orderId/fix-board': typeof AppGalleryOrdersOrderIdFixBoardRoute
  '/booking/me/orders/$orderId/album': typeof BookingMeOrdersOrderIdAlbumRoute
  '/booking/me/orders/$orderId/gallery': typeof BookingMeOrdersOrderIdGalleryRoute
  '/booking/me/orders/$orderId/original-album': typeof BookingMeOrdersOrderIdOriginalAlbumRoute
  '/gallery/orders/$orderId/': typeof AppGalleryOrdersOrderIdIndexRoute
  '/gallery/orders/$orderId/compose/$albumId': typeof AppGalleryOrdersOrderIdComposeAlbumIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/login': typeof LoginRoute
  '/concept-guides': typeof AppConceptGuidesRouteRoute
  '/compose-backdrops': typeof AppComposeBackdropsRoute
  '/costumes': typeof AppCostumesRoute
  '/customer-chats': typeof AppCustomerChatsRoute
  '/dashboard': typeof AppDashboardRoute
  '/dispatch-board': typeof AppDispatchBoardRoute
  '/dispatch-points': typeof AppDispatchPointsRoute
  '/dispatch-settings': typeof AppDispatchSettingsRoute
  '/expense-claims': typeof AppExpenseClaimsRoute
  '/fraud-board': typeof AppFraudBoardRoute
  '/home': typeof AppHomeRoute
  '/hunch-room': typeof AppHunchRoomRoute
  '/integrations': typeof AppIntegrationsRoute
  '/kenh-nhan-su': typeof AppKenhNhanSuRoute
  '/me': typeof AppMeRoute
  '/medals': typeof AppMedalsRoute
  '/my-dispatch': typeof AppMyDispatchRoute
  '/notifications': typeof AppNotificationsRoute
  '/payments': typeof AppPaymentsRoute
  '/print-ops-report': typeof AppPrintOpsReportRoute
  '/printer-invoices': typeof AppPrinterInvoicesRoute
  '/products': typeof AppProductsRoute
  '/quote-approvals': typeof AppQuoteApprovalsRoute
  '/regulations': typeof AppRegulationsRoute
  '/retouch-dispatch-settings': typeof AppRetouchDispatchSettingsRoute
  '/sealed-inbox': typeof AppSealedInboxRoute
  '/sealed-inbox-reader': typeof AppSealedInboxReaderRoute
  '/set-board': typeof AppSetBoardRoute
  '/staff': typeof AppStaffRoute
  '/staff-checkins': typeof AppStaffCheckinsRoute
  '/staff-productivity': typeof AppStaffProductivityRoute
  '/store-board': typeof AppStoreBoardRoute
  '/tra-do': typeof AppTraDoRoute
  '/attention': typeof DevAttentionRoute
  '/components': typeof DevComponentsRoute
  '/cskh-preview': typeof DevCskhPreviewRoute
  '/ekip-proof': typeof DevEkipProofRoute
  '/face-probe': typeof DevFaceProbeRoute
  '/kpi-scope': typeof DevKpiScopeRoute
  '/salary-detail': typeof DevSalaryDetailRoute
  '/album/$token': typeof AlbumTokenRoute
  '/anh-in/$token': typeof AnhInTokenRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/booking/$branchCode': typeof BookingBranchCodeRoute
  '/booking/me': typeof BookingMeRoute
  '/chon-anh/$token': typeof ChonAnhTokenRoute
  '/muon-tra-do': typeof AppMuonTraDoLazyRoute
  '/booking': typeof BookingIndexRoute
  '/albums/ledger': typeof AppAlbumsLedgerRoute
  '/cskh/$orderId': typeof AppCskhOrderIdRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/customers/order-history': typeof AppCustomersOrderHistoryRoute
  '/me/collection': typeof AppMeCollectionRoute
  '/me/journey': typeof AppMeJourneyRoute
  '/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/orders/new': typeof AppOrdersNewRoute
  '/performance/admin': typeof AppPerformanceAdminRoute
  '/performance/review': typeof AppPerformanceReviewRoute
  '/promos/$promoId': typeof AppPromosPromoIdRoute
  '/qc-desk/anh-the': typeof AppQcDeskAnhTheRoute
  '/qc-desk/hanh-trinh': typeof AppQcDeskHanhTrinhRoute
  '/qc-desk/hau-kiem': typeof AppQcDeskHauKiemRoute
  '/quote-print/$orderId': typeof AppQuotePrintOrderIdRoute
  '/salary-analytics/$staffId': typeof AppSalaryAnalyticsStaffIdRoute
  '/sealed-inbox-reader/$id': typeof AppSealedInboxReaderIdRoute
  '/sealed-inbox/$id': typeof AppSealedInboxIdRoute
  '/gallery/share/$token': typeof GalleryShareTokenRoute
  '/affiliates': typeof AppAffiliatesIndexRoute
  '/albums': typeof AppAlbumsIndexRoute
  '/branch-kpi': typeof AppBranchKpiIndexRoute
  '/branch-scores': typeof AppBranchScoresIndexRoute
  '/branch-shifts': typeof AppBranchShiftsIndexRoute
  '/business-plan': typeof AppBusinessPlanIndexRoute
  '/cash-chain': typeof AppCashChainIndexRoute
  '/cash-drawer': typeof AppCashDrawerIndexRoute
  '/complaints': typeof AppComplaintsIndexRoute
  '/cskh': typeof AppCskhIndexRoute
  '/customer-voice': typeof AppCustomerVoiceIndexRoute
  '/customers': typeof AppCustomersIndexRoute
  '/director-board': typeof AppDirectorBoardIndexRoute
  '/ekip-config': typeof AppEkipConfigIndexRoute
  '/ekip-pool': typeof AppEkipPoolIndexRoute
  '/ekip-shifts': typeof AppEkipShiftsIndexRoute
  '/equipment-overdue': typeof AppEquipmentOverdueIndexRoute
  '/expenses': typeof AppExpensesIndexRoute
  '/general-settings': typeof AppGeneralSettingsIndexRoute
  '/half-day-slots': typeof AppHalfDaySlotsIndexRoute
  '/kho-y-tuong': typeof AppKhoYTuongIndexRoute
  '/kho': typeof AppKhoIndexRoute
  '/letan-shifts': typeof AppLetanShiftsIndexRoute
  '/marketing': typeof AppMarketingIndexRoute
  '/mgmt-performance': typeof AppMgmtPerformanceIndexRoute
  '/obligations': typeof AppObligationsIndexRoute
  '/orders': typeof AppOrdersIndexRoute
  '/payroll': typeof AppPayrollIndexRoute
  '/performance': typeof AppPerformanceIndexRoute
  '/photo-work': typeof AppPhotoWorkIndexRoute
  '/print-ops': typeof AppPrintOpsIndexRoute
  '/promos': typeof AppPromosIndexRoute
  '/qc-board': typeof AppQcBoardIndexRoute
  '/qc-desk': typeof AppQcDeskIndexRoute
  '/qc-overview': typeof AppQcOverviewIndexRoute
  '/quality': typeof AppQualityIndexRoute
  '/rankings': typeof AppRankingsIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/retouch': typeof AppRetouchIndexRoute
  '/salary-analytics': typeof AppSalaryAnalyticsIndexRoute
  '/salary-rules-v2': typeof AppSalaryRulesV2IndexRoute
  '/salary-rules': typeof AppSalaryRulesIndexRoute
  '/sales-team': typeof AppSalesTeamIndexRoute
  '/schedule': typeof AppScheduleIndexRoute
  '/spot-checks': typeof AppSpotChecksIndexRoute
  '/suggestions': typeof AppSuggestionsIndexRoute
  '/viec-can-xem': typeof AppViecCanXemIndexRoute
  '/zalo': typeof AppZaloIndexRoute
  '/fraud-board/bang-chung/$id': typeof AppFraudBoardBangChungIdRoute
  '/fraud-board/cap-nguoi/$key': typeof AppFraudBoardCapNguoiKeyRoute
  '/fraud-board/cap-so/$key': typeof AppFraudBoardCapSoKeyRoute
  '/fraud-board/khach-bi-mat/$id': typeof AppFraudBoardKhachBiMatIdRoute
  '/gallery/albums/$containerId': typeof AppGalleryAlbumsContainerIdRoute
  '/qc-overview/qc/$staffId': typeof AppQcOverviewQcStaffIdRoute
  '/retouch/orders/$orderId': typeof AppRetouchOrdersOrderIdRoute
  '/gallery/orders/$orderId/fix-board': typeof AppGalleryOrdersOrderIdFixBoardRoute
  '/booking/me/orders/$orderId/album': typeof BookingMeOrdersOrderIdAlbumRoute
  '/booking/me/orders/$orderId/gallery': typeof BookingMeOrdersOrderIdGalleryRoute
  '/booking/me/orders/$orderId/original-album': typeof BookingMeOrdersOrderIdOriginalAlbumRoute
  '/gallery/orders/$orderId': typeof AppGalleryOrdersOrderIdIndexRoute
  '/gallery/orders/$orderId/compose/$albumId': typeof AppGalleryOrdersOrderIdComposeAlbumIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/_app': typeof AppRouteWithChildren
  '/_dev': typeof DevRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/affiliates': typeof AppAffiliatesRouteRouteWithChildren
  '/_app/albums': typeof AppAlbumsRouteRouteWithChildren
  '/_app/branch-kpi': typeof AppBranchKpiRouteRouteWithChildren
  '/_app/branch-scores': typeof AppBranchScoresRouteRouteWithChildren
  '/_app/branch-shifts': typeof AppBranchShiftsRouteRouteWithChildren
  '/_app/business-plan': typeof AppBusinessPlanRouteRouteWithChildren
  '/_app/cash-chain': typeof AppCashChainRouteRouteWithChildren
  '/_app/cash-drawer': typeof AppCashDrawerRouteRouteWithChildren
  '/_app/complaints': typeof AppComplaintsRouteRouteWithChildren
  '/_app/concept-guides': typeof AppConceptGuidesRouteRoute
  '/_app/cskh': typeof AppCskhRouteRouteWithChildren
  '/_app/customer-voice': typeof AppCustomerVoiceRouteRouteWithChildren
  '/_app/customers': typeof AppCustomersRouteRouteWithChildren
  '/_app/director-board': typeof AppDirectorBoardRouteRouteWithChildren
  '/_app/ekip-config': typeof AppEkipConfigRouteRouteWithChildren
  '/_app/ekip-pool': typeof AppEkipPoolRouteRouteWithChildren
  '/_app/ekip-shifts': typeof AppEkipShiftsRouteRouteWithChildren
  '/_app/equipment-overdue': typeof AppEquipmentOverdueRouteRouteWithChildren
  '/_app/expenses': typeof AppExpensesRouteRouteWithChildren
  '/_app/general-settings': typeof AppGeneralSettingsRouteRouteWithChildren
  '/_app/half-day-slots': typeof AppHalfDaySlotsRouteRouteWithChildren
  '/_app/kho': typeof AppKhoRouteRouteWithChildren
  '/_app/kho-y-tuong': typeof AppKhoYTuongRouteRouteWithChildren
  '/_app/letan-shifts': typeof AppLetanShiftsRouteRouteWithChildren
  '/_app/marketing': typeof AppMarketingRouteRouteWithChildren
  '/_app/mgmt-performance': typeof AppMgmtPerformanceRouteRouteWithChildren
  '/_app/obligations': typeof AppObligationsRouteRouteWithChildren
  '/_app/orders': typeof AppOrdersRouteRouteWithChildren
  '/_app/payroll': typeof AppPayrollRouteRouteWithChildren
  '/_app/performance': typeof AppPerformanceRouteRouteWithChildren
  '/_app/photo-work': typeof AppPhotoWorkRouteRouteWithChildren
  '/_app/print-ops': typeof AppPrintOpsRouteRouteWithChildren
  '/_app/promos': typeof AppPromosRouteRouteWithChildren
  '/_app/qc-board': typeof AppQcBoardRouteRouteWithChildren
  '/_app/qc-desk': typeof AppQcDeskRouteRouteWithChildren
  '/_app/qc-overview': typeof AppQcOverviewRouteRouteWithChildren
  '/_app/quality': typeof AppQualityRouteRouteWithChildren
  '/_app/rankings': typeof AppRankingsRouteRouteWithChildren
  '/_app/reports': typeof AppReportsRouteRouteWithChildren
  '/_app/retouch': typeof AppRetouchRouteRouteWithChildren
  '/_app/salary-analytics': typeof AppSalaryAnalyticsRouteRouteWithChildren
  '/_app/salary-rules': typeof AppSalaryRulesRouteRouteWithChildren
  '/_app/salary-rules-v2': typeof AppSalaryRulesV2RouteRouteWithChildren
  '/_app/sales-team': typeof AppSalesTeamRouteRouteWithChildren
  '/_app/schedule': typeof AppScheduleRouteRouteWithChildren
  '/_app/spot-checks': typeof AppSpotChecksRouteRouteWithChildren
  '/_app/suggestions': typeof AppSuggestionsRouteRouteWithChildren
  '/_app/viec-can-xem': typeof AppViecCanXemRouteRouteWithChildren
  '/_app/zalo': typeof AppZaloRouteRouteWithChildren
  '/_app/compose-backdrops': typeof AppComposeBackdropsRoute
  '/_app/costumes': typeof AppCostumesRoute
  '/_app/customer-chats': typeof AppCustomerChatsRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/dispatch-board': typeof AppDispatchBoardRoute
  '/_app/dispatch-points': typeof AppDispatchPointsRoute
  '/_app/dispatch-settings': typeof AppDispatchSettingsRoute
  '/_app/expense-claims': typeof AppExpenseClaimsRoute
  '/_app/fraud-board': typeof AppFraudBoardRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/hunch-room': typeof AppHunchRoomRoute
  '/_app/integrations': typeof AppIntegrationsRoute
  '/_app/kenh-nhan-su': typeof AppKenhNhanSuRoute
  '/_app/me': typeof AppMeRoute
  '/_app/medals': typeof AppMedalsRoute
  '/_app/my-dispatch': typeof AppMyDispatchRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/payments': typeof AppPaymentsRoute
  '/_app/print-ops-report': typeof AppPrintOpsReportRoute
  '/_app/printer-invoices': typeof AppPrinterInvoicesRoute
  '/_app/products': typeof AppProductsRoute
  '/_app/quote-approvals': typeof AppQuoteApprovalsRoute
  '/_app/regulations': typeof AppRegulationsRoute
  '/_app/retouch-dispatch-settings': typeof AppRetouchDispatchSettingsRoute
  '/_app/sealed-inbox': typeof AppSealedInboxRoute
  '/_app/sealed-inbox-reader': typeof AppSealedInboxReaderRoute
  '/_app/set-board': typeof AppSetBoardRoute
  '/_app/staff': typeof AppStaffRoute
  '/_app/staff-checkins': typeof AppStaffCheckinsRoute
  '/_app/staff-productivity': typeof AppStaffProductivityRoute
  '/_app/store-board': typeof AppStoreBoardRoute
  '/_app/tra-do': typeof AppTraDoRoute
  '/_dev/attention': typeof DevAttentionRoute
  '/_dev/components': typeof DevComponentsRoute
  '/_dev/cskh-preview': typeof DevCskhPreviewRoute
  '/_dev/ekip-proof': typeof DevEkipProofRoute
  '/_dev/face-probe': typeof DevFaceProbeRoute
  '/_dev/kpi-scope': typeof DevKpiScopeRoute
  '/_dev/salary-detail': typeof DevSalaryDetailRoute
  '/album/$token': typeof AlbumTokenRoute
  '/anh-in/$token': typeof AnhInTokenRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/booking/$branchCode': typeof BookingBranchCodeRoute
  '/booking/me': typeof BookingMeRoute
  '/chon-anh/$token': typeof ChonAnhTokenRoute
  '/_app/muon-tra-do': typeof AppMuonTraDoLazyRoute
  '/booking/': typeof BookingIndexRoute
  '/_app/albums/ledger': typeof AppAlbumsLedgerRoute
  '/_app/cskh/$orderId': typeof AppCskhOrderIdRoute
  '/_app/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/_app/customers/order-history': typeof AppCustomersOrderHistoryRoute
  '/_app/me_/collection': typeof AppMeCollectionRoute
  '/_app/me_/journey': typeof AppMeJourneyRoute
  '/_app/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/_app/orders/new': typeof AppOrdersNewRoute
  '/_app/performance/admin': typeof AppPerformanceAdminRoute
  '/_app/performance/review': typeof AppPerformanceReviewRoute
  '/_app/promos/$promoId': typeof AppPromosPromoIdRoute
  '/_app/qc-desk/anh-the': typeof AppQcDeskAnhTheRoute
  '/_app/qc-desk/hanh-trinh': typeof AppQcDeskHanhTrinhRoute
  '/_app/qc-desk/hau-kiem': typeof AppQcDeskHauKiemRoute
  '/_app/quote-print/$orderId': typeof AppQuotePrintOrderIdRoute
  '/_app/salary-analytics/$staffId': typeof AppSalaryAnalyticsStaffIdRoute
  '/_app/sealed-inbox-reader_/$id': typeof AppSealedInboxReaderIdRoute
  '/_app/sealed-inbox_/$id': typeof AppSealedInboxIdRoute
  '/gallery/share/$token': typeof GalleryShareTokenRoute
  '/_app/affiliates/': typeof AppAffiliatesIndexRoute
  '/_app/albums/': typeof AppAlbumsIndexRoute
  '/_app/branch-kpi/': typeof AppBranchKpiIndexRoute
  '/_app/branch-scores/': typeof AppBranchScoresIndexRoute
  '/_app/branch-shifts/': typeof AppBranchShiftsIndexRoute
  '/_app/business-plan/': typeof AppBusinessPlanIndexRoute
  '/_app/cash-chain/': typeof AppCashChainIndexRoute
  '/_app/cash-drawer/': typeof AppCashDrawerIndexRoute
  '/_app/complaints/': typeof AppComplaintsIndexRoute
  '/_app/cskh/': typeof AppCskhIndexRoute
  '/_app/customer-voice/': typeof AppCustomerVoiceIndexRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/director-board/': typeof AppDirectorBoardIndexRoute
  '/_app/ekip-config/': typeof AppEkipConfigIndexRoute
  '/_app/ekip-pool/': typeof AppEkipPoolIndexRoute
  '/_app/ekip-shifts/': typeof AppEkipShiftsIndexRoute
  '/_app/equipment-overdue/': typeof AppEquipmentOverdueIndexRoute
  '/_app/expenses/': typeof AppExpensesIndexRoute
  '/_app/general-settings/': typeof AppGeneralSettingsIndexRoute
  '/_app/half-day-slots/': typeof AppHalfDaySlotsIndexRoute
  '/_app/kho-y-tuong/': typeof AppKhoYTuongIndexRoute
  '/_app/kho/': typeof AppKhoIndexRoute
  '/_app/letan-shifts/': typeof AppLetanShiftsIndexRoute
  '/_app/marketing/': typeof AppMarketingIndexRoute
  '/_app/mgmt-performance/': typeof AppMgmtPerformanceIndexRoute
  '/_app/obligations/': typeof AppObligationsIndexRoute
  '/_app/orders/': typeof AppOrdersIndexRoute
  '/_app/payroll/': typeof AppPayrollIndexRoute
  '/_app/performance/': typeof AppPerformanceIndexRoute
  '/_app/photo-work/': typeof AppPhotoWorkIndexRoute
  '/_app/print-ops/': typeof AppPrintOpsIndexRoute
  '/_app/promos/': typeof AppPromosIndexRoute
  '/_app/qc-board/': typeof AppQcBoardIndexRoute
  '/_app/qc-desk/': typeof AppQcDeskIndexRoute
  '/_app/qc-overview/': typeof AppQcOverviewIndexRoute
  '/_app/quality/': typeof AppQualityIndexRoute
  '/_app/rankings/': typeof AppRankingsIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_app/retouch/': typeof AppRetouchIndexRoute
  '/_app/salary-analytics/': typeof AppSalaryAnalyticsIndexRoute
  '/_app/salary-rules-v2/': typeof AppSalaryRulesV2IndexRoute
  '/_app/salary-rules/': typeof AppSalaryRulesIndexRoute
  '/_app/sales-team/': typeof AppSalesTeamIndexRoute
  '/_app/schedule/': typeof AppScheduleIndexRoute
  '/_app/spot-checks/': typeof AppSpotChecksIndexRoute
  '/_app/suggestions/': typeof AppSuggestionsIndexRoute
  '/_app/viec-can-xem/': typeof AppViecCanXemIndexRoute
  '/_app/zalo/': typeof AppZaloIndexRoute
  '/_app/gallery/orders/$orderId': typeof AppGalleryOrdersOrderIdRouteRouteWithChildren
  '/_app/fraud-board_/bang-chung/$id': typeof AppFraudBoardBangChungIdRoute
  '/_app/fraud-board_/cap-nguoi/$key': typeof AppFraudBoardCapNguoiKeyRoute
  '/_app/fraud-board_/cap-so/$key': typeof AppFraudBoardCapSoKeyRoute
  '/_app/fraud-board_/khach-bi-mat/$id': typeof AppFraudBoardKhachBiMatIdRoute
  '/_app/gallery/albums/$containerId': typeof AppGalleryAlbumsContainerIdRoute
  '/_app/qc-overview/qc/$staffId': typeof AppQcOverviewQcStaffIdRoute
  '/_app/retouch/orders/$orderId': typeof AppRetouchOrdersOrderIdRoute
  '/_app/gallery/orders/$orderId/fix-board': typeof AppGalleryOrdersOrderIdFixBoardRoute
  '/booking/me_/orders/$orderId/album': typeof BookingMeOrdersOrderIdAlbumRoute
  '/booking/me_/orders/$orderId/gallery': typeof BookingMeOrdersOrderIdGalleryRoute
  '/booking/me_/orders/$orderId/original-album': typeof BookingMeOrdersOrderIdOriginalAlbumRoute
  '/_app/gallery/orders/$orderId/': typeof AppGalleryOrdersOrderIdIndexRoute
  '/_app/gallery/orders/$orderId/compose/$albumId': typeof AppGalleryOrdersOrderIdComposeAlbumIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/403'
    | '/404'
    | '/login'
    | '/affiliates'
    | '/albums'
    | '/branch-kpi'
    | '/branch-scores'
    | '/branch-shifts'
    | '/business-plan'
    | '/cash-chain'
    | '/cash-drawer'
    | '/complaints'
    | '/concept-guides'
    | '/cskh'
    | '/customer-voice'
    | '/customers'
    | '/director-board'
    | '/ekip-config'
    | '/ekip-pool'
    | '/ekip-shifts'
    | '/equipment-overdue'
    | '/expenses'
    | '/general-settings'
    | '/half-day-slots'
    | '/kho'
    | '/kho-y-tuong'
    | '/letan-shifts'
    | '/marketing'
    | '/mgmt-performance'
    | '/obligations'
    | '/orders'
    | '/payroll'
    | '/performance'
    | '/photo-work'
    | '/print-ops'
    | '/promos'
    | '/qc-board'
    | '/qc-desk'
    | '/qc-overview'
    | '/quality'
    | '/rankings'
    | '/reports'
    | '/retouch'
    | '/salary-analytics'
    | '/salary-rules'
    | '/salary-rules-v2'
    | '/sales-team'
    | '/schedule'
    | '/spot-checks'
    | '/suggestions'
    | '/viec-can-xem'
    | '/zalo'
    | '/compose-backdrops'
    | '/costumes'
    | '/customer-chats'
    | '/dashboard'
    | '/dispatch-board'
    | '/dispatch-points'
    | '/dispatch-settings'
    | '/expense-claims'
    | '/fraud-board'
    | '/home'
    | '/hunch-room'
    | '/integrations'
    | '/kenh-nhan-su'
    | '/me'
    | '/medals'
    | '/my-dispatch'
    | '/notifications'
    | '/payments'
    | '/print-ops-report'
    | '/printer-invoices'
    | '/products'
    | '/quote-approvals'
    | '/regulations'
    | '/retouch-dispatch-settings'
    | '/sealed-inbox'
    | '/sealed-inbox-reader'
    | '/set-board'
    | '/staff'
    | '/staff-checkins'
    | '/staff-productivity'
    | '/store-board'
    | '/tra-do'
    | '/attention'
    | '/components'
    | '/cskh-preview'
    | '/ekip-proof'
    | '/face-probe'
    | '/kpi-scope'
    | '/salary-detail'
    | '/album/$token'
    | '/anh-in/$token'
    | '/auth/callback'
    | '/booking/$branchCode'
    | '/booking/me'
    | '/chon-anh/$token'
    | '/muon-tra-do'
    | '/booking/'
    | '/albums/ledger'
    | '/cskh/$orderId'
    | '/customers/$customerId'
    | '/customers/order-history'
    | '/me/collection'
    | '/me/journey'
    | '/orders/$orderId'
    | '/orders/new'
    | '/performance/admin'
    | '/performance/review'
    | '/promos/$promoId'
    | '/qc-desk/anh-the'
    | '/qc-desk/hanh-trinh'
    | '/qc-desk/hau-kiem'
    | '/quote-print/$orderId'
    | '/salary-analytics/$staffId'
    | '/sealed-inbox-reader/$id'
    | '/sealed-inbox/$id'
    | '/gallery/share/$token'
    | '/affiliates/'
    | '/albums/'
    | '/branch-kpi/'
    | '/branch-scores/'
    | '/branch-shifts/'
    | '/business-plan/'
    | '/cash-chain/'
    | '/cash-drawer/'
    | '/complaints/'
    | '/cskh/'
    | '/customer-voice/'
    | '/customers/'
    | '/director-board/'
    | '/ekip-config/'
    | '/ekip-pool/'
    | '/ekip-shifts/'
    | '/equipment-overdue/'
    | '/expenses/'
    | '/general-settings/'
    | '/half-day-slots/'
    | '/kho-y-tuong/'
    | '/kho/'
    | '/letan-shifts/'
    | '/marketing/'
    | '/mgmt-performance/'
    | '/obligations/'
    | '/orders/'
    | '/payroll/'
    | '/performance/'
    | '/photo-work/'
    | '/print-ops/'
    | '/promos/'
    | '/qc-board/'
    | '/qc-desk/'
    | '/qc-overview/'
    | '/quality/'
    | '/rankings/'
    | '/reports/'
    | '/retouch/'
    | '/salary-analytics/'
    | '/salary-rules-v2/'
    | '/salary-rules/'
    | '/sales-team/'
    | '/schedule/'
    | '/spot-checks/'
    | '/suggestions/'
    | '/viec-can-xem/'
    | '/zalo/'
    | '/gallery/orders/$orderId'
    | '/fraud-board/bang-chung/$id'
    | '/fraud-board/cap-nguoi/$key'
    | '/fraud-board/cap-so/$key'
    | '/fraud-board/khach-bi-mat/$id'
    | '/gallery/albums/$containerId'
    | '/qc-overview/qc/$staffId'
    | '/retouch/orders/$orderId'
    | '/gallery/orders/$orderId/fix-board'
    | '/booking/me/orders/$orderId/album'
    | '/booking/me/orders/$orderId/gallery'
    | '/booking/me/orders/$orderId/original-album'
    | '/gallery/orders/$orderId/'
    | '/gallery/orders/$orderId/compose/$albumId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/403'
    | '/404'
    | '/login'
    | '/concept-guides'
    | '/compose-backdrops'
    | '/costumes'
    | '/customer-chats'
    | '/dashboard'
    | '/dispatch-board'
    | '/dispatch-points'
    | '/dispatch-settings'
    | '/expense-claims'
    | '/fraud-board'
    | '/home'
    | '/hunch-room'
    | '/integrations'
    | '/kenh-nhan-su'
    | '/me'
    | '/medals'
    | '/my-dispatch'
    | '/notifications'
    | '/payments'
    | '/print-ops-report'
    | '/printer-invoices'
    | '/products'
    | '/quote-approvals'
    | '/regulations'
    | '/retouch-dispatch-settings'
    | '/sealed-inbox'
    | '/sealed-inbox-reader'
    | '/set-board'
    | '/staff'
    | '/staff-checkins'
    | '/staff-productivity'
    | '/store-board'
    | '/tra-do'
    | '/attention'
    | '/components'
    | '/cskh-preview'
    | '/ekip-proof'
    | '/face-probe'
    | '/kpi-scope'
    | '/salary-detail'
    | '/album/$token'
    | '/anh-in/$token'
    | '/auth/callback'
    | '/booking/$branchCode'
    | '/booking/me'
    | '/chon-anh/$token'
    | '/muon-tra-do'
    | '/booking'
    | '/albums/ledger'
    | '/cskh/$orderId'
    | '/customers/$customerId'
    | '/customers/order-history'
    | '/me/collection'
    | '/me/journey'
    | '/orders/$orderId'
    | '/orders/new'
    | '/performance/admin'
    | '/performance/review'
    | '/promos/$promoId'
    | '/qc-desk/anh-the'
    | '/qc-desk/hanh-trinh'
    | '/qc-desk/hau-kiem'
    | '/quote-print/$orderId'
    | '/salary-analytics/$staffId'
    | '/sealed-inbox-reader/$id'
    | '/sealed-inbox/$id'
    | '/gallery/share/$token'
    | '/affiliates'
    | '/albums'
    | '/branch-kpi'
    | '/branch-scores'
    | '/branch-shifts'
    | '/business-plan'
    | '/cash-chain'
    | '/cash-drawer'
    | '/complaints'
    | '/cskh'
    | '/customer-voice'
    | '/customers'
    | '/director-board'
    | '/ekip-config'
    | '/ekip-pool'
    | '/ekip-shifts'
    | '/equipment-overdue'
    | '/expenses'
    | '/general-settings'
    | '/half-day-slots'
    | '/kho-y-tuong'
    | '/kho'
    | '/letan-shifts'
    | '/marketing'
    | '/mgmt-performance'
    | '/obligations'
    | '/orders'
    | '/payroll'
    | '/performance'
    | '/photo-work'
    | '/print-ops'
    | '/promos'
    | '/qc-board'
    | '/qc-desk'
    | '/qc-overview'
    | '/quality'
    | '/rankings'
    | '/reports'
    | '/retouch'
    | '/salary-analytics'
    | '/salary-rules-v2'
    | '/salary-rules'
    | '/sales-team'
    | '/schedule'
    | '/spot-checks'
    | '/suggestions'
    | '/viec-can-xem'
    | '/zalo'
    | '/fraud-board/bang-chung/$id'
    | '/fraud-board/cap-nguoi/$key'
    | '/fraud-board/cap-so/$key'
    | '/fraud-board/khach-bi-mat/$id'
    | '/gallery/albums/$containerId'
    | '/qc-overview/qc/$staffId'
    | '/retouch/orders/$orderId'
    | '/gallery/orders/$orderId/fix-board'
    | '/booking/me/orders/$orderId/album'
    | '/booking/me/orders/$orderId/gallery'
    | '/booking/me/orders/$orderId/original-album'
    | '/gallery/orders/$orderId'
    | '/gallery/orders/$orderId/compose/$albumId'
  id:
    | '__root__'
    | '/'
    | '/403'
    | '/404'
    | '/_app'
    | '/_dev'
    | '/login'
    | '/_app/affiliates'
    | '/_app/albums'
    | '/_app/branch-kpi'
    | '/_app/branch-scores'
    | '/_app/branch-shifts'
    | '/_app/business-plan'
    | '/_app/cash-chain'
    | '/_app/cash-drawer'
    | '/_app/complaints'
    | '/_app/concept-guides'
    | '/_app/cskh'
    | '/_app/customer-voice'
    | '/_app/customers'
    | '/_app/director-board'
    | '/_app/ekip-config'
    | '/_app/ekip-pool'
    | '/_app/ekip-shifts'
    | '/_app/equipment-overdue'
    | '/_app/expenses'
    | '/_app/general-settings'
    | '/_app/half-day-slots'
    | '/_app/kho'
    | '/_app/kho-y-tuong'
    | '/_app/letan-shifts'
    | '/_app/marketing'
    | '/_app/mgmt-performance'
    | '/_app/obligations'
    | '/_app/orders'
    | '/_app/payroll'
    | '/_app/performance'
    | '/_app/photo-work'
    | '/_app/print-ops'
    | '/_app/promos'
    | '/_app/qc-board'
    | '/_app/qc-desk'
    | '/_app/qc-overview'
    | '/_app/quality'
    | '/_app/rankings'
    | '/_app/reports'
    | '/_app/retouch'
    | '/_app/salary-analytics'
    | '/_app/salary-rules'
    | '/_app/salary-rules-v2'
    | '/_app/sales-team'
    | '/_app/schedule'
    | '/_app/spot-checks'
    | '/_app/suggestions'
    | '/_app/viec-can-xem'
    | '/_app/zalo'
    | '/_app/compose-backdrops'
    | '/_app/costumes'
    | '/_app/customer-chats'
    | '/_app/dashboard'
    | '/_app/dispatch-board'
    | '/_app/dispatch-points'
    | '/_app/dispatch-settings'
    | '/_app/expense-claims'
    | '/_app/fraud-board'
    | '/_app/home'
    | '/_app/hunch-room'
    | '/_app/integrations'
    | '/_app/kenh-nhan-su'
    | '/_app/me'
    | '/_app/medals'
    | '/_app/my-dispatch'
    | '/_app/notifications'
    | '/_app/payments'
    | '/_app/print-ops-report'
    | '/_app/printer-invoices'
    | '/_app/products'
    | '/_app/quote-approvals'
    | '/_app/regulations'
    | '/_app/retouch-dispatch-settings'
    | '/_app/sealed-inbox'
    | '/_app/sealed-inbox-reader'
    | '/_app/set-board'
    | '/_app/staff'
    | '/_app/staff-checkins'
    | '/_app/staff-productivity'
    | '/_app/store-board'
    | '/_app/tra-do'
    | '/_dev/attention'
    | '/_dev/components'
    | '/_dev/cskh-preview'
    | '/_dev/ekip-proof'
    | '/_dev/face-probe'
    | '/_dev/kpi-scope'
    | '/_dev/salary-detail'
    | '/album/$token'
    | '/anh-in/$token'
    | '/auth/callback'
    | '/booking/$branchCode'
    | '/booking/me'
    | '/chon-anh/$token'
    | '/_app/muon-tra-do'
    | '/booking/'
    | '/_app/albums/ledger'
    | '/_app/cskh/$orderId'
    | '/_app/customers/$customerId'
    | '/_app/customers/order-history'
    | '/_app/me_/collection'
    | '/_app/me_/journey'
    | '/_app/orders/$orderId'
    | '/_app/orders/new'
    | '/_app/performance/admin'
    | '/_app/performance/review'
    | '/_app/promos/$promoId'
    | '/_app/qc-desk/anh-the'
    | '/_app/qc-desk/hanh-trinh'
    | '/_app/qc-desk/hau-kiem'
    | '/_app/quote-print/$orderId'
    | '/_app/salary-analytics/$staffId'
    | '/_app/sealed-inbox-reader_/$id'
    | '/_app/sealed-inbox_/$id'
    | '/gallery/share/$token'
    | '/_app/affiliates/'
    | '/_app/albums/'
    | '/_app/branch-kpi/'
    | '/_app/branch-scores/'
    | '/_app/branch-shifts/'
    | '/_app/business-plan/'
    | '/_app/cash-chain/'
    | '/_app/cash-drawer/'
    | '/_app/complaints/'
    | '/_app/cskh/'
    | '/_app/customer-voice/'
    | '/_app/customers/'
    | '/_app/director-board/'
    | '/_app/ekip-config/'
    | '/_app/ekip-pool/'
    | '/_app/ekip-shifts/'
    | '/_app/equipment-overdue/'
    | '/_app/expenses/'
    | '/_app/general-settings/'
    | '/_app/half-day-slots/'
    | '/_app/kho-y-tuong/'
    | '/_app/kho/'
    | '/_app/letan-shifts/'
    | '/_app/marketing/'
    | '/_app/mgmt-performance/'
    | '/_app/obligations/'
    | '/_app/orders/'
    | '/_app/payroll/'
    | '/_app/performance/'
    | '/_app/photo-work/'
    | '/_app/print-ops/'
    | '/_app/promos/'
    | '/_app/qc-board/'
    | '/_app/qc-desk/'
    | '/_app/qc-overview/'
    | '/_app/quality/'
    | '/_app/rankings/'
    | '/_app/reports/'
    | '/_app/retouch/'
    | '/_app/salary-analytics/'
    | '/_app/salary-rules-v2/'
    | '/_app/salary-rules/'
    | '/_app/sales-team/'
    | '/_app/schedule/'
    | '/_app/spot-checks/'
    | '/_app/suggestions/'
    | '/_app/viec-can-xem/'
    | '/_app/zalo/'
    | '/_app/gallery/orders/$orderId'
    | '/_app/fraud-board_/bang-chung/$id'
    | '/_app/fraud-board_/cap-nguoi/$key'
    | '/_app/fraud-board_/cap-so/$key'
    | '/_app/fraud-board_/khach-bi-mat/$id'
    | '/_app/gallery/albums/$containerId'
    | '/_app/qc-overview/qc/$staffId'
    | '/_app/retouch/orders/$orderId'
    | '/_app/gallery/orders/$orderId/fix-board'
    | '/booking/me_/orders/$orderId/album'
    | '/booking/me_/orders/$orderId/gallery'
    | '/booking/me_/orders/$orderId/original-album'
    | '/_app/gallery/orders/$orderId/'
    | '/_app/gallery/orders/$orderId/compose/$albumId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R403Route: typeof R403Route
  R404Route: typeof R404Route
  AppRoute: typeof AppRouteWithChildren
  DevRoute: typeof DevRouteWithChildren
  LoginRoute: typeof LoginRoute
  AlbumTokenRoute: typeof AlbumTokenRoute
  AnhInTokenRoute: typeof AnhInTokenRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  BookingBranchCodeRoute: typeof BookingBranchCodeRoute
  BookingMeRoute: typeof BookingMeRoute
  ChonAnhTokenRoute: typeof ChonAnhTokenRoute
  BookingIndexRoute: typeof BookingIndexRoute
  GalleryShareTokenRoute: typeof GalleryShareTokenRoute
  BookingMeOrdersOrderIdAlbumRoute: typeof BookingMeOrdersOrderIdAlbumRoute
  BookingMeOrdersOrderIdGalleryRoute: typeof BookingMeOrdersOrderIdGalleryRoute
  BookingMeOrdersOrderIdOriginalAlbumRoute: typeof BookingMeOrdersOrderIdOriginalAlbumRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dev': {
      id: '/_dev'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/': {
      id: '/booking/'
      path: '/booking'
      fullPath: '/booking/'
      preLoaderRoute: typeof BookingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/muon-tra-do': {
      id: '/_app/muon-tra-do'
      path: '/muon-tra-do'
      fullPath: '/muon-tra-do'
      preLoaderRoute: typeof AppMuonTraDoLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/chon-anh/$token': {
      id: '/chon-anh/$token'
      path: '/chon-anh/$token'
      fullPath: '/chon-anh/$token'
      preLoaderRoute: typeof ChonAnhTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/me': {
      id: '/booking/me'
      path: '/booking/me'
      fullPath: '/booking/me'
      preLoaderRoute: typeof BookingMeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/$branchCode': {
      id: '/booking/$branchCode'
      path: '/booking/$branchCode'
      fullPath: '/booking/$branchCode'
      preLoaderRoute: typeof BookingBranchCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/anh-in/$token': {
      id: '/anh-in/$token'
      path: '/anh-in/$token'
      fullPath: '/anh-in/$token'
      preLoaderRoute: typeof AnhInTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/album/$token': {
      id: '/album/$token'
      path: '/album/$token'
      fullPath: '/album/$token'
      preLoaderRoute: typeof AlbumTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dev/salary-detail': {
      id: '/_dev/salary-detail'
      path: '/salary-detail'
      fullPath: '/salary-detail'
      preLoaderRoute: typeof DevSalaryDetailRouteImport
      parentRoute: typeof DevRoute
    }
    '/_dev/kpi-scope': {
      id: '/_dev/kpi-scope'
      path: '/kpi-scope'
      fullPath: '/kpi-scope'
      preLoaderRoute: typeof DevKpiScopeRouteImport
      parentRoute: typeof DevRoute
    }
    '/_dev/face-probe': {
      id: '/_dev/face-probe'
      path: '/face-probe'
      fullPath: '/face-probe'
      preLoaderRoute: typeof DevFaceProbeRouteImport
      parentRoute: typeof DevRoute
    }
    '/_dev/ekip-proof': {
      id: '/_dev/ekip-proof'
      path: '/ekip-proof'
      fullPath: '/ekip-proof'
      preLoaderRoute: typeof DevEkipProofRouteImport
      parentRoute: typeof DevRoute
    }
    '/_dev/cskh-preview': {
      id: '/_dev/cskh-preview'
      path: '/cskh-preview'
      fullPath: '/cskh-preview'
      preLoaderRoute: typeof DevCskhPreviewRouteImport
      parentRoute: typeof DevRoute
    }
    '/_dev/components': {
      id: '/_dev/components'
      path: '/components'
      fullPath: '/components'
      preLoaderRoute: typeof DevComponentsRouteImport
      parentRoute: typeof DevRoute
    }
    '/_dev/attention': {
      id: '/_dev/attention'
      path: '/attention'
      fullPath: '/attention'
      preLoaderRoute: typeof DevAttentionRouteImport
      parentRoute: typeof DevRoute
    }
    '/_app/tra-do': {
      id: '/_app/tra-do'
      path: '/tra-do'
      fullPath: '/tra-do'
      preLoaderRoute: typeof AppTraDoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/store-board': {
      id: '/_app/store-board'
      path: '/store-board'
      fullPath: '/store-board'
      preLoaderRoute: typeof AppStoreBoardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staff-productivity': {
      id: '/_app/staff-productivity'
      path: '/staff-productivity'
      fullPath: '/staff-productivity'
      preLoaderRoute: typeof AppStaffProductivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staff-checkins': {
      id: '/_app/staff-checkins'
      path: '/staff-checkins'
      fullPath: '/staff-checkins'
      preLoaderRoute: typeof AppStaffCheckinsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staff': {
      id: '/_app/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof AppStaffRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/set-board': {
      id: '/_app/set-board'
      path: '/set-board'
      fullPath: '/set-board'
      preLoaderRoute: typeof AppSetBoardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sealed-inbox-reader': {
      id: '/_app/sealed-inbox-reader'
      path: '/sealed-inbox-reader'
      fullPath: '/sealed-inbox-reader'
      preLoaderRoute: typeof AppSealedInboxReaderRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sealed-inbox': {
      id: '/_app/sealed-inbox'
      path: '/sealed-inbox'
      fullPath: '/sealed-inbox'
      preLoaderRoute: typeof AppSealedInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/retouch-dispatch-settings': {
      id: '/_app/retouch-dispatch-settings'
      path: '/retouch-dispatch-settings'
      fullPath: '/retouch-dispatch-settings'
      preLoaderRoute: typeof AppRetouchDispatchSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/regulations': {
      id: '/_app/regulations'
      path: '/regulations'
      fullPath: '/regulations'
      preLoaderRoute: typeof AppRegulationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quote-approvals': {
      id: '/_app/quote-approvals'
      path: '/quote-approvals'
      fullPath: '/quote-approvals'
      preLoaderRoute: typeof AppQuoteApprovalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products': {
      id: '/_app/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AppProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/printer-invoices': {
      id: '/_app/printer-invoices'
      path: '/printer-invoices'
      fullPath: '/printer-invoices'
      preLoaderRoute: typeof AppPrinterInvoicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/print-ops-report': {
      id: '/_app/print-ops-report'
      path: '/print-ops-report'
      fullPath: '/print-ops-report'
      preLoaderRoute: typeof AppPrintOpsReportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payments': {
      id: '/_app/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof AppPaymentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-dispatch': {
      id: '/_app/my-dispatch'
      path: '/my-dispatch'
      fullPath: '/my-dispatch'
      preLoaderRoute: typeof AppMyDispatchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/medals': {
      id: '/_app/medals'
      path: '/medals'
      fullPath: '/medals'
      preLoaderRoute: typeof AppMedalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me': {
      id: '/_app/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof AppMeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kenh-nhan-su': {
      id: '/_app/kenh-nhan-su'
      path: '/kenh-nhan-su'
      fullPath: '/kenh-nhan-su'
      preLoaderRoute: typeof AppKenhNhanSuRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integrations': {
      id: '/_app/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AppIntegrationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hunch-room': {
      id: '/_app/hunch-room'
      path: '/hunch-room'
      fullPath: '/hunch-room'
      preLoaderRoute: typeof AppHunchRoomRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fraud-board': {
      id: '/_app/fraud-board'
      path: '/fraud-board'
      fullPath: '/fraud-board'
      preLoaderRoute: typeof AppFraudBoardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/expense-claims': {
      id: '/_app/expense-claims'
      path: '/expense-claims'
      fullPath: '/expense-claims'
      preLoaderRoute: typeof AppExpenseClaimsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dispatch-settings': {
      id: '/_app/dispatch-settings'
      path: '/dispatch-settings'
      fullPath: '/dispatch-settings'
      preLoaderRoute: typeof AppDispatchSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dispatch-points': {
      id: '/_app/dispatch-points'
      path: '/dispatch-points'
      fullPath: '/dispatch-points'
      preLoaderRoute: typeof AppDispatchPointsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dispatch-board': {
      id: '/_app/dispatch-board'
      path: '/dispatch-board'
      fullPath: '/dispatch-board'
      preLoaderRoute: typeof AppDispatchBoardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customer-chats': {
      id: '/_app/customer-chats'
      path: '/customer-chats'
      fullPath: '/customer-chats'
      preLoaderRoute: typeof AppCustomerChatsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/costumes': {
      id: '/_app/costumes'
      path: '/costumes'
      fullPath: '/costumes'
      preLoaderRoute: typeof AppCostumesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/compose-backdrops': {
      id: '/_app/compose-backdrops'
      path: '/compose-backdrops'
      fullPath: '/compose-backdrops'
      preLoaderRoute: typeof AppComposeBackdropsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/zalo': {
      id: '/_app/zalo'
      path: '/zalo'
      fullPath: '/zalo'
      preLoaderRoute: typeof AppZaloRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/viec-can-xem': {
      id: '/_app/viec-can-xem'
      path: '/viec-can-xem'
      fullPath: '/viec-can-xem'
      preLoaderRoute: typeof AppViecCanXemRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suggestions': {
      id: '/_app/suggestions'
      path: '/suggestions'
      fullPath: '/suggestions'
      preLoaderRoute: typeof AppSuggestionsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/spot-checks': {
      id: '/_app/spot-checks'
      path: '/spot-checks'
      fullPath: '/spot-checks'
      preLoaderRoute: typeof AppSpotChecksRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/schedule': {
      id: '/_app/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AppScheduleRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales-team': {
      id: '/_app/sales-team'
      path: '/sales-team'
      fullPath: '/sales-team'
      preLoaderRoute: typeof AppSalesTeamRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/salary-rules-v2': {
      id: '/_app/salary-rules-v2'
      path: '/salary-rules-v2'
      fullPath: '/salary-rules-v2'
      preLoaderRoute: typeof AppSalaryRulesV2RouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/salary-rules': {
      id: '/_app/salary-rules'
      path: '/salary-rules'
      fullPath: '/salary-rules'
      preLoaderRoute: typeof AppSalaryRulesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/salary-analytics': {
      id: '/_app/salary-analytics'
      path: '/salary-analytics'
      fullPath: '/salary-analytics'
      preLoaderRoute: typeof AppSalaryAnalyticsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/retouch': {
      id: '/_app/retouch'
      path: '/retouch'
      fullPath: '/retouch'
      preLoaderRoute: typeof AppRetouchRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rankings': {
      id: '/_app/rankings'
      path: '/rankings'
      fullPath: '/rankings'
      preLoaderRoute: typeof AppRankingsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quality': {
      id: '/_app/quality'
      path: '/quality'
      fullPath: '/quality'
      preLoaderRoute: typeof AppQualityRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/qc-overview': {
      id: '/_app/qc-overview'
      path: '/qc-overview'
      fullPath: '/qc-overview'
      preLoaderRoute: typeof AppQcOverviewRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/qc-desk': {
      id: '/_app/qc-desk'
      path: '/qc-desk'
      fullPath: '/qc-desk'
      preLoaderRoute: typeof AppQcDeskRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/qc-board': {
      id: '/_app/qc-board'
      path: '/qc-board'
      fullPath: '/qc-board'
      preLoaderRoute: typeof AppQcBoardRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/promos': {
      id: '/_app/promos'
      path: '/promos'
      fullPath: '/promos'
      preLoaderRoute: typeof AppPromosRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/print-ops': {
      id: '/_app/print-ops'
      path: '/print-ops'
      fullPath: '/print-ops'
      preLoaderRoute: typeof AppPrintOpsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/photo-work': {
      id: '/_app/photo-work'
      path: '/photo-work'
      fullPath: '/photo-work'
      preLoaderRoute: typeof AppPhotoWorkRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/performance': {
      id: '/_app/performance'
      path: '/performance'
      fullPath: '/performance'
      preLoaderRoute: typeof AppPerformanceRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payroll': {
      id: '/_app/payroll'
      path: '/payroll'
      fullPath: '/payroll'
      preLoaderRoute: typeof AppPayrollRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders': {
      id: '/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppOrdersRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/obligations': {
      id: '/_app/obligations'
      path: '/obligations'
      fullPath: '/obligations'
      preLoaderRoute: typeof AppObligationsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mgmt-performance': {
      id: '/_app/mgmt-performance'
      path: '/mgmt-performance'
      fullPath: '/mgmt-performance'
      preLoaderRoute: typeof AppMgmtPerformanceRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing': {
      id: '/_app/marketing'
      path: '/marketing'
      fullPath: '/marketing'
      preLoaderRoute: typeof AppMarketingRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/letan-shifts': {
      id: '/_app/letan-shifts'
      path: '/letan-shifts'
      fullPath: '/letan-shifts'
      preLoaderRoute: typeof AppLetanShiftsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kho-y-tuong': {
      id: '/_app/kho-y-tuong'
      path: '/kho-y-tuong'
      fullPath: '/kho-y-tuong'
      preLoaderRoute: typeof AppKhoYTuongRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kho': {
      id: '/_app/kho'
      path: '/kho'
      fullPath: '/kho'
      preLoaderRoute: typeof AppKhoRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/half-day-slots': {
      id: '/_app/half-day-slots'
      path: '/half-day-slots'
      fullPath: '/half-day-slots'
      preLoaderRoute: typeof AppHalfDaySlotsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/general-settings': {
      id: '/_app/general-settings'
      path: '/general-settings'
      fullPath: '/general-settings'
      preLoaderRoute: typeof AppGeneralSettingsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/expenses': {
      id: '/_app/expenses'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof AppExpensesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/equipment-overdue': {
      id: '/_app/equipment-overdue'
      path: '/equipment-overdue'
      fullPath: '/equipment-overdue'
      preLoaderRoute: typeof AppEquipmentOverdueRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ekip-shifts': {
      id: '/_app/ekip-shifts'
      path: '/ekip-shifts'
      fullPath: '/ekip-shifts'
      preLoaderRoute: typeof AppEkipShiftsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ekip-pool': {
      id: '/_app/ekip-pool'
      path: '/ekip-pool'
      fullPath: '/ekip-pool'
      preLoaderRoute: typeof AppEkipPoolRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ekip-config': {
      id: '/_app/ekip-config'
      path: '/ekip-config'
      fullPath: '/ekip-config'
      preLoaderRoute: typeof AppEkipConfigRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/director-board': {
      id: '/_app/director-board'
      path: '/director-board'
      fullPath: '/director-board'
      preLoaderRoute: typeof AppDirectorBoardRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers': {
      id: '/_app/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AppCustomersRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customer-voice': {
      id: '/_app/customer-voice'
      path: '/customer-voice'
      fullPath: '/customer-voice'
      preLoaderRoute: typeof AppCustomerVoiceRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cskh': {
      id: '/_app/cskh'
      path: '/cskh'
      fullPath: '/cskh'
      preLoaderRoute: typeof AppCskhRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/concept-guides': {
      id: '/_app/concept-guides'
      path: '/concept-guides'
      fullPath: '/concept-guides'
      preLoaderRoute: typeof AppConceptGuidesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/complaints': {
      id: '/_app/complaints'
      path: '/complaints'
      fullPath: '/complaints'
      preLoaderRoute: typeof AppComplaintsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cash-drawer': {
      id: '/_app/cash-drawer'
      path: '/cash-drawer'
      fullPath: '/cash-drawer'
      preLoaderRoute: typeof AppCashDrawerRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cash-chain': {
      id: '/_app/cash-chain'
      path: '/cash-chain'
      fullPath: '/cash-chain'
      preLoaderRoute: typeof AppCashChainRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business-plan': {
      id: '/_app/business-plan'
      path: '/business-plan'
      fullPath: '/business-plan'
      preLoaderRoute: typeof AppBusinessPlanRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/branch-shifts': {
      id: '/_app/branch-shifts'
      path: '/branch-shifts'
      fullPath: '/branch-shifts'
      preLoaderRoute: typeof AppBranchShiftsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/branch-scores': {
      id: '/_app/branch-scores'
      path: '/branch-scores'
      fullPath: '/branch-scores'
      preLoaderRoute: typeof AppBranchScoresRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/branch-kpi': {
      id: '/_app/branch-kpi'
      path: '/branch-kpi'
      fullPath: '/branch-kpi'
      preLoaderRoute: typeof AppBranchKpiRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/albums': {
      id: '/_app/albums'
      path: '/albums'
      fullPath: '/albums'
      preLoaderRoute: typeof AppAlbumsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/affiliates': {
      id: '/_app/affiliates'
      path: '/affiliates'
      fullPath: '/affiliates'
      preLoaderRoute: typeof AppAffiliatesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/zalo/': {
      id: '/_app/zalo/'
      path: '/'
      fullPath: '/zalo/'
      preLoaderRoute: typeof AppZaloIndexRouteImport
      parentRoute: typeof AppZaloRouteRoute
    }
    '/_app/viec-can-xem/': {
      id: '/_app/viec-can-xem/'
      path: '/'
      fullPath: '/viec-can-xem/'
      preLoaderRoute: typeof AppViecCanXemIndexRouteImport
      parentRoute: typeof AppViecCanXemRouteRoute
    }
    '/_app/suggestions/': {
      id: '/_app/suggestions/'
      path: '/'
      fullPath: '/suggestions/'
      preLoaderRoute: typeof AppSuggestionsIndexRouteImport
      parentRoute: typeof AppSuggestionsRouteRoute
    }
    '/_app/spot-checks/': {
      id: '/_app/spot-checks/'
      path: '/'
      fullPath: '/spot-checks/'
      preLoaderRoute: typeof AppSpotChecksIndexRouteImport
      parentRoute: typeof AppSpotChecksRouteRoute
    }
    '/_app/schedule/': {
      id: '/_app/schedule/'
      path: '/'
      fullPath: '/schedule/'
      preLoaderRoute: typeof AppScheduleIndexRouteImport
      parentRoute: typeof AppScheduleRouteRoute
    }
    '/_app/sales-team/': {
      id: '/_app/sales-team/'
      path: '/'
      fullPath: '/sales-team/'
      preLoaderRoute: typeof AppSalesTeamIndexRouteImport
      parentRoute: typeof AppSalesTeamRouteRoute
    }
    '/_app/salary-rules/': {
      id: '/_app/salary-rules/'
      path: '/'
      fullPath: '/salary-rules/'
      preLoaderRoute: typeof AppSalaryRulesIndexRouteImport
      parentRoute: typeof AppSalaryRulesRouteRoute
    }
    '/_app/salary-rules-v2/': {
      id: '/_app/salary-rules-v2/'
      path: '/'
      fullPath: '/salary-rules-v2/'
      preLoaderRoute: typeof AppSalaryRulesV2IndexRouteImport
      parentRoute: typeof AppSalaryRulesV2RouteRoute
    }
    '/_app/salary-analytics/': {
      id: '/_app/salary-analytics/'
      path: '/'
      fullPath: '/salary-analytics/'
      preLoaderRoute: typeof AppSalaryAnalyticsIndexRouteImport
      parentRoute: typeof AppSalaryAnalyticsRouteRoute
    }
    '/_app/retouch/': {
      id: '/_app/retouch/'
      path: '/'
      fullPath: '/retouch/'
      preLoaderRoute: typeof AppRetouchIndexRouteImport
      parentRoute: typeof AppRetouchRouteRoute
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppReportsRouteRoute
    }
    '/_app/rankings/': {
      id: '/_app/rankings/'
      path: '/'
      fullPath: '/rankings/'
      preLoaderRoute: typeof AppRankingsIndexRouteImport
      parentRoute: typeof AppRankingsRouteRoute
    }
    '/_app/quality/': {
      id: '/_app/quality/'
      path: '/'
      fullPath: '/quality/'
      preLoaderRoute: typeof AppQualityIndexRouteImport
      parentRoute: typeof AppQualityRouteRoute
    }
    '/_app/qc-overview/': {
      id: '/_app/qc-overview/'
      path: '/'
      fullPath: '/qc-overview/'
      preLoaderRoute: typeof AppQcOverviewIndexRouteImport
      parentRoute: typeof AppQcOverviewRouteRoute
    }
    '/_app/qc-desk/': {
      id: '/_app/qc-desk/'
      path: '/'
      fullPath: '/qc-desk/'
      preLoaderRoute: typeof AppQcDeskIndexRouteImport
      parentRoute: typeof AppQcDeskRouteRoute
    }
    '/_app/qc-board/': {
      id: '/_app/qc-board/'
      path: '/'
      fullPath: '/qc-board/'
      preLoaderRoute: typeof AppQcBoardIndexRouteImport
      parentRoute: typeof AppQcBoardRouteRoute
    }
    '/_app/promos/': {
      id: '/_app/promos/'
      path: '/'
      fullPath: '/promos/'
      preLoaderRoute: typeof AppPromosIndexRouteImport
      parentRoute: typeof AppPromosRouteRoute
    }
    '/_app/print-ops/': {
      id: '/_app/print-ops/'
      path: '/'
      fullPath: '/print-ops/'
      preLoaderRoute: typeof AppPrintOpsIndexRouteImport
      parentRoute: typeof AppPrintOpsRouteRoute
    }
    '/_app/photo-work/': {
      id: '/_app/photo-work/'
      path: '/'
      fullPath: '/photo-work/'
      preLoaderRoute: typeof AppPhotoWorkIndexRouteImport
      parentRoute: typeof AppPhotoWorkRouteRoute
    }
    '/_app/performance/': {
      id: '/_app/performance/'
      path: '/'
      fullPath: '/performance/'
      preLoaderRoute: typeof AppPerformanceIndexRouteImport
      parentRoute: typeof AppPerformanceRouteRoute
    }
    '/_app/payroll/': {
      id: '/_app/payroll/'
      path: '/'
      fullPath: '/payroll/'
      preLoaderRoute: typeof AppPayrollIndexRouteImport
      parentRoute: typeof AppPayrollRouteRoute
    }
    '/_app/orders/': {
      id: '/_app/orders/'
      path: '/'
      fullPath: '/orders/'
      preLoaderRoute: typeof AppOrdersIndexRouteImport
      parentRoute: typeof AppOrdersRouteRoute
    }
    '/_app/obligations/': {
      id: '/_app/obligations/'
      path: '/'
      fullPath: '/obligations/'
      preLoaderRoute: typeof AppObligationsIndexRouteImport
      parentRoute: typeof AppObligationsRouteRoute
    }
    '/_app/mgmt-performance/': {
      id: '/_app/mgmt-performance/'
      path: '/'
      fullPath: '/mgmt-performance/'
      preLoaderRoute: typeof AppMgmtPerformanceIndexRouteImport
      parentRoute: typeof AppMgmtPerformanceRouteRoute
    }
    '/_app/marketing/': {
      id: '/_app/marketing/'
      path: '/'
      fullPath: '/marketing/'
      preLoaderRoute: typeof AppMarketingIndexRouteImport
      parentRoute: typeof AppMarketingRouteRoute
    }
    '/_app/letan-shifts/': {
      id: '/_app/letan-shifts/'
      path: '/'
      fullPath: '/letan-shifts/'
      preLoaderRoute: typeof AppLetanShiftsIndexRouteImport
      parentRoute: typeof AppLetanShiftsRouteRoute
    }
    '/_app/kho/': {
      id: '/_app/kho/'
      path: '/'
      fullPath: '/kho/'
      preLoaderRoute: typeof AppKhoIndexRouteImport
      parentRoute: typeof AppKhoRouteRoute
    }
    '/_app/kho-y-tuong/': {
      id: '/_app/kho-y-tuong/'
      path: '/'
      fullPath: '/kho-y-tuong/'
      preLoaderRoute: typeof AppKhoYTuongIndexRouteImport
      parentRoute: typeof AppKhoYTuongRouteRoute
    }
    '/_app/half-day-slots/': {
      id: '/_app/half-day-slots/'
      path: '/'
      fullPath: '/half-day-slots/'
      preLoaderRoute: typeof AppHalfDaySlotsIndexRouteImport
      parentRoute: typeof AppHalfDaySlotsRouteRoute
    }
    '/_app/general-settings/': {
      id: '/_app/general-settings/'
      path: '/'
      fullPath: '/general-settings/'
      preLoaderRoute: typeof AppGeneralSettingsIndexRouteImport
      parentRoute: typeof AppGeneralSettingsRouteRoute
    }
    '/_app/expenses/': {
      id: '/_app/expenses/'
      path: '/'
      fullPath: '/expenses/'
      preLoaderRoute: typeof AppExpensesIndexRouteImport
      parentRoute: typeof AppExpensesRouteRoute
    }
    '/_app/equipment-overdue/': {
      id: '/_app/equipment-overdue/'
      path: '/'
      fullPath: '/equipment-overdue/'
      preLoaderRoute: typeof AppEquipmentOverdueIndexRouteImport
      parentRoute: typeof AppEquipmentOverdueRouteRoute
    }
    '/_app/ekip-shifts/': {
      id: '/_app/ekip-shifts/'
      path: '/'
      fullPath: '/ekip-shifts/'
      preLoaderRoute: typeof AppEkipShiftsIndexRouteImport
      parentRoute: typeof AppEkipShiftsRouteRoute
    }
    '/_app/ekip-pool/': {
      id: '/_app/ekip-pool/'
      path: '/'
      fullPath: '/ekip-pool/'
      preLoaderRoute: typeof AppEkipPoolIndexRouteImport
      parentRoute: typeof AppEkipPoolRouteRoute
    }
    '/_app/ekip-config/': {
      id: '/_app/ekip-config/'
      path: '/'
      fullPath: '/ekip-config/'
      preLoaderRoute: typeof AppEkipConfigIndexRouteImport
      parentRoute: typeof AppEkipConfigRouteRoute
    }
    '/_app/director-board/': {
      id: '/_app/director-board/'
      path: '/'
      fullPath: '/director-board/'
      preLoaderRoute: typeof AppDirectorBoardIndexRouteImport
      parentRoute: typeof AppDirectorBoardRouteRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppCustomersRouteRoute
    }
    '/_app/customer-voice/': {
      id: '/_app/customer-voice/'
      path: '/'
      fullPath: '/customer-voice/'
      preLoaderRoute: typeof AppCustomerVoiceIndexRouteImport
      parentRoute: typeof AppCustomerVoiceRouteRoute
    }
    '/_app/cskh/': {
      id: '/_app/cskh/'
      path: '/'
      fullPath: '/cskh/'
      preLoaderRoute: typeof AppCskhIndexRouteImport
      parentRoute: typeof AppCskhRouteRoute
    }
    '/_app/complaints/': {
      id: '/_app/complaints/'
      path: '/'
      fullPath: '/complaints/'
      preLoaderRoute: typeof AppComplaintsIndexRouteImport
      parentRoute: typeof AppComplaintsRouteRoute
    }
    '/_app/cash-drawer/': {
      id: '/_app/cash-drawer/'
      path: '/'
      fullPath: '/cash-drawer/'
      preLoaderRoute: typeof AppCashDrawerIndexRouteImport
      parentRoute: typeof AppCashDrawerRouteRoute
    }
    '/_app/cash-chain/': {
      id: '/_app/cash-chain/'
      path: '/'
      fullPath: '/cash-chain/'
      preLoaderRoute: typeof AppCashChainIndexRouteImport
      parentRoute: typeof AppCashChainRouteRoute
    }
    '/_app/business-plan/': {
      id: '/_app/business-plan/'
      path: '/'
      fullPath: '/business-plan/'
      preLoaderRoute: typeof AppBusinessPlanIndexRouteImport
      parentRoute: typeof AppBusinessPlanRouteRoute
    }
    '/_app/branch-shifts/': {
      id: '/_app/branch-shifts/'
      path: '/'
      fullPath: '/branch-shifts/'
      preLoaderRoute: typeof AppBranchShiftsIndexRouteImport
      parentRoute: typeof AppBranchShiftsRouteRoute
    }
    '/_app/branch-scores/': {
      id: '/_app/branch-scores/'
      path: '/'
      fullPath: '/branch-scores/'
      preLoaderRoute: typeof AppBranchScoresIndexRouteImport
      parentRoute: typeof AppBranchScoresRouteRoute
    }
    '/_app/branch-kpi/': {
      id: '/_app/branch-kpi/'
      path: '/'
      fullPath: '/branch-kpi/'
      preLoaderRoute: typeof AppBranchKpiIndexRouteImport
      parentRoute: typeof AppBranchKpiRouteRoute
    }
    '/_app/albums/': {
      id: '/_app/albums/'
      path: '/'
      fullPath: '/albums/'
      preLoaderRoute: typeof AppAlbumsIndexRouteImport
      parentRoute: typeof AppAlbumsRouteRoute
    }
    '/_app/affiliates/': {
      id: '/_app/affiliates/'
      path: '/'
      fullPath: '/affiliates/'
      preLoaderRoute: typeof AppAffiliatesIndexRouteImport
      parentRoute: typeof AppAffiliatesRouteRoute
    }
    '/gallery/share/$token': {
      id: '/gallery/share/$token'
      path: '/gallery/share/$token'
      fullPath: '/gallery/share/$token'
      preLoaderRoute: typeof GalleryShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/sealed-inbox_/$id': {
      id: '/_app/sealed-inbox_/$id'
      path: '/sealed-inbox/$id'
      fullPath: '/sealed-inbox/$id'
      preLoaderRoute: typeof AppSealedInboxIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sealed-inbox-reader_/$id': {
      id: '/_app/sealed-inbox-reader_/$id'
      path: '/sealed-inbox-reader/$id'
      fullPath: '/sealed-inbox-reader/$id'
      preLoaderRoute: typeof AppSealedInboxReaderIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/salary-analytics/$staffId': {
      id: '/_app/salary-analytics/$staffId'
      path: '/$staffId'
      fullPath: '/salary-analytics/$staffId'
      preLoaderRoute: typeof AppSalaryAnalyticsStaffIdRouteImport
      parentRoute: typeof AppSalaryAnalyticsRouteRoute
    }
    '/_app/quote-print/$orderId': {
      id: '/_app/quote-print/$orderId'
      path: '/quote-print/$orderId'
      fullPath: '/quote-print/$orderId'
      preLoaderRoute: typeof AppQuotePrintOrderIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/qc-desk/hau-kiem': {
      id: '/_app/qc-desk/hau-kiem'
      path: '/hau-kiem'
      fullPath: '/qc-desk/hau-kiem'
      preLoaderRoute: typeof AppQcDeskHauKiemRouteImport
      parentRoute: typeof AppQcDeskRouteRoute
    }
    '/_app/qc-desk/hanh-trinh': {
      id: '/_app/qc-desk/hanh-trinh'
      path: '/hanh-trinh'
      fullPath: '/qc-desk/hanh-trinh'
      preLoaderRoute: typeof AppQcDeskHanhTrinhRouteImport
      parentRoute: typeof AppQcDeskRouteRoute
    }
    '/_app/qc-desk/anh-the': {
      id: '/_app/qc-desk/anh-the'
      path: '/anh-the'
      fullPath: '/qc-desk/anh-the'
      preLoaderRoute: typeof AppQcDeskAnhTheRouteImport
      parentRoute: typeof AppQcDeskRouteRoute
    }
    '/_app/promos/$promoId': {
      id: '/_app/promos/$promoId'
      path: '/$promoId'
      fullPath: '/promos/$promoId'
      preLoaderRoute: typeof AppPromosPromoIdRouteImport
      parentRoute: typeof AppPromosRouteRoute
    }
    '/_app/performance/review': {
      id: '/_app/performance/review'
      path: '/review'
      fullPath: '/performance/review'
      preLoaderRoute: typeof AppPerformanceReviewRouteImport
      parentRoute: typeof AppPerformanceRouteRoute
    }
    '/_app/performance/admin': {
      id: '/_app/performance/admin'
      path: '/admin'
      fullPath: '/performance/admin'
      preLoaderRoute: typeof AppPerformanceAdminRouteImport
      parentRoute: typeof AppPerformanceRouteRoute
    }
    '/_app/orders/new': {
      id: '/_app/orders/new'
      path: '/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof AppOrdersNewRouteImport
      parentRoute: typeof AppOrdersRouteRoute
    }
    '/_app/orders/$orderId': {
      id: '/_app/orders/$orderId'
      path: '/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AppOrdersOrderIdRouteImport
      parentRoute: typeof AppOrdersRouteRoute
    }
    '/_app/me_/journey': {
      id: '/_app/me_/journey'
      path: '/me/journey'
      fullPath: '/me/journey'
      preLoaderRoute: typeof AppMeJourneyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me_/collection': {
      id: '/_app/me_/collection'
      path: '/me/collection'
      fullPath: '/me/collection'
      preLoaderRoute: typeof AppMeCollectionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/order-history': {
      id: '/_app/customers/order-history'
      path: '/order-history'
      fullPath: '/customers/order-history'
      preLoaderRoute: typeof AppCustomersOrderHistoryRouteImport
      parentRoute: typeof AppCustomersRouteRoute
    }
    '/_app/customers/$customerId': {
      id: '/_app/customers/$customerId'
      path: '/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AppCustomersCustomerIdRouteImport
      parentRoute: typeof AppCustomersRouteRoute
    }
    '/_app/cskh/$orderId': {
      id: '/_app/cskh/$orderId'
      path: '/$orderId'
      fullPath: '/cskh/$orderId'
      preLoaderRoute: typeof AppCskhOrderIdRouteImport
      parentRoute: typeof AppCskhRouteRoute
    }
    '/_app/albums/ledger': {
      id: '/_app/albums/ledger'
      path: '/ledger'
      fullPath: '/albums/ledger'
      preLoaderRoute: typeof AppAlbumsLedgerRouteImport
      parentRoute: typeof AppAlbumsRouteRoute
    }
    '/_app/retouch/orders/$orderId': {
      id: '/_app/retouch/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/retouch/orders/$orderId'
      preLoaderRoute: typeof AppRetouchOrdersOrderIdRouteImport
      parentRoute: typeof AppRetouchRouteRoute
    }
    '/_app/qc-overview/qc/$staffId': {
      id: '/_app/qc-overview/qc/$staffId'
      path: '/qc/$staffId'
      fullPath: '/qc-overview/qc/$staffId'
      preLoaderRoute: typeof AppQcOverviewQcStaffIdRouteImport
      parentRoute: typeof AppQcOverviewRouteRoute
    }
    '/_app/gallery/albums/$containerId': {
      id: '/_app/gallery/albums/$containerId'
      path: '/gallery/albums/$containerId'
      fullPath: '/gallery/albums/$containerId'
      preLoaderRoute: typeof AppGalleryAlbumsContainerIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fraud-board_/khach-bi-mat/$id': {
      id: '/_app/fraud-board_/khach-bi-mat/$id'
      path: '/fraud-board/khach-bi-mat/$id'
      fullPath: '/fraud-board/khach-bi-mat/$id'
      preLoaderRoute: typeof AppFraudBoardKhachBiMatIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fraud-board_/cap-so/$key': {
      id: '/_app/fraud-board_/cap-so/$key'
      path: '/fraud-board/cap-so/$key'
      fullPath: '/fraud-board/cap-so/$key'
      preLoaderRoute: typeof AppFraudBoardCapSoKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fraud-board_/cap-nguoi/$key': {
      id: '/_app/fraud-board_/cap-nguoi/$key'
      path: '/fraud-board/cap-nguoi/$key'
      fullPath: '/fraud-board/cap-nguoi/$key'
      preLoaderRoute: typeof AppFraudBoardCapNguoiKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fraud-board_/bang-chung/$id': {
      id: '/_app/fraud-board_/bang-chung/$id'
      path: '/fraud-board/bang-chung/$id'
      fullPath: '/fraud-board/bang-chung/$id'
      preLoaderRoute: typeof AppFraudBoardBangChungIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gallery/orders/$orderId': {
      id: '/_app/gallery/orders/$orderId'
      path: '/gallery/orders/$orderId'
      fullPath: '/gallery/orders/$orderId'
      preLoaderRoute: typeof AppGalleryOrdersOrderIdRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gallery/orders/$orderId/': {
      id: '/_app/gallery/orders/$orderId/'
      path: '/'
      fullPath: '/gallery/orders/$orderId/'
      preLoaderRoute: typeof AppGalleryOrdersOrderIdIndexRouteImport
      parentRoute: typeof AppGalleryOrdersOrderIdRouteRoute
    }
    '/booking/me_/orders/$orderId/original-album': {
      id: '/booking/me_/orders/$orderId/original-album'
      path: '/booking/me/orders/$orderId/original-album'
      fullPath: '/booking/me/orders/$orderId/original-album'
      preLoaderRoute: typeof BookingMeOrdersOrderIdOriginalAlbumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/me_/orders/$orderId/gallery': {
      id: '/booking/me_/orders/$orderId/gallery'
      path: '/booking/me/orders/$orderId/gallery'
      fullPath: '/booking/me/orders/$orderId/gallery'
      preLoaderRoute: typeof BookingMeOrdersOrderIdGalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/me_/orders/$orderId/album': {
      id: '/booking/me_/orders/$orderId/album'
      path: '/booking/me/orders/$orderId/album'
      fullPath: '/booking/me/orders/$orderId/album'
      preLoaderRoute: typeof BookingMeOrdersOrderIdAlbumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/gallery/orders/$orderId/fix-board': {
      id: '/_app/gallery/orders/$orderId/fix-board'
      path: '/fix-board'
      fullPath: '/gallery/orders/$orderId/fix-board'
      preLoaderRoute: typeof AppGalleryOrdersOrderIdFixBoardRouteImport
      parentRoute: typeof AppGalleryOrdersOrderIdRouteRoute
    }
    '/_app/gallery/orders/$orderId/compose/$albumId': {
      id: '/_app/gallery/orders/$orderId/compose/$albumId'
      path: '/compose/$albumId'
      fullPath: '/gallery/orders/$orderId/compose/$albumId'
      preLoaderRoute: typeof AppGalleryOrdersOrderIdComposeAlbumIdRouteImport
      parentRoute: typeof AppGalleryOrdersOrderIdRouteRoute
    }
  }
}

interface AppAffiliatesRouteRouteChildren {
  AppAffiliatesIndexRoute: typeof AppAffiliatesIndexRoute
}

const AppAffiliatesRouteRouteChildren: AppAffiliatesRouteRouteChildren = {
  AppAffiliatesIndexRoute: AppAffiliatesIndexRoute,
}

const AppAffiliatesRouteRouteWithChildren =
  AppAffiliatesRouteRoute._addFileChildren(AppAffiliatesRouteRouteChildren)

interface AppAlbumsRouteRouteChildren {
  AppAlbumsLedgerRoute: typeof AppAlbumsLedgerRoute
  AppAlbumsIndexRoute: typeof AppAlbumsIndexRoute
}

const AppAlbumsRouteRouteChildren: AppAlbumsRouteRouteChildren = {
  AppAlbumsLedgerRoute: AppAlbumsLedgerRoute,
  AppAlbumsIndexRoute: AppAlbumsIndexRoute,
}

const AppAlbumsRouteRouteWithChildren = AppAlbumsRouteRoute._addFileChildren(
  AppAlbumsRouteRouteChildren,
)

interface AppBranchKpiRouteRouteChildren {
  AppBranchKpiIndexRoute: typeof AppBranchKpiIndexRoute
}

const AppBranchKpiRouteRouteChildren: AppBranchKpiRouteRouteChildren = {
  AppBranchKpiIndexRoute: AppBranchKpiIndexRoute,
}

const AppBranchKpiRouteRouteWithChildren =
  AppBranchKpiRouteRoute._addFileChildren(AppBranchKpiRouteRouteChildren)

interface AppBranchScoresRouteRouteChildren {
  AppBranchScoresIndexRoute: typeof AppBranchScoresIndexRoute
}

const AppBranchScoresRouteRouteChildren: AppBranchScoresRouteRouteChildren = {
  AppBranchScoresIndexRoute: AppBranchScoresIndexRoute,
}

const AppBranchScoresRouteRouteWithChildren =
  AppBranchScoresRouteRoute._addFileChildren(AppBranchScoresRouteRouteChildren)

interface AppBranchShiftsRouteRouteChildren {
  AppBranchShiftsIndexRoute: typeof AppBranchShiftsIndexRoute
}

const AppBranchShiftsRouteRouteChildren: AppBranchShiftsRouteRouteChildren = {
  AppBranchShiftsIndexRoute: AppBranchShiftsIndexRoute,
}

const AppBranchShiftsRouteRouteWithChildren =
  AppBranchShiftsRouteRoute._addFileChildren(AppBranchShiftsRouteRouteChildren)

interface AppBusinessPlanRouteRouteChildren {
  AppBusinessPlanIndexRoute: typeof AppBusinessPlanIndexRoute
}

const AppBusinessPlanRouteRouteChildren: AppBusinessPlanRouteRouteChildren = {
  AppBusinessPlanIndexRoute: AppBusinessPlanIndexRoute,
}

const AppBusinessPlanRouteRouteWithChildren =
  AppBusinessPlanRouteRoute._addFileChildren(AppBusinessPlanRouteRouteChildren)

interface AppCashChainRouteRouteChildren {
  AppCashChainIndexRoute: typeof AppCashChainIndexRoute
}

const AppCashChainRouteRouteChildren: AppCashChainRouteRouteChildren = {
  AppCashChainIndexRoute: AppCashChainIndexRoute,
}

const AppCashChainRouteRouteWithChildren =
  AppCashChainRouteRoute._addFileChildren(AppCashChainRouteRouteChildren)

interface AppCashDrawerRouteRouteChildren {
  AppCashDrawerIndexRoute: typeof AppCashDrawerIndexRoute
}

const AppCashDrawerRouteRouteChildren: AppCashDrawerRouteRouteChildren = {
  AppCashDrawerIndexRoute: AppCashDrawerIndexRoute,
}

const AppCashDrawerRouteRouteWithChildren =
  AppCashDrawerRouteRoute._addFileChildren(AppCashDrawerRouteRouteChildren)

interface AppComplaintsRouteRouteChildren {
  AppComplaintsIndexRoute: typeof AppComplaintsIndexRoute
}

const AppComplaintsRouteRouteChildren: AppComplaintsRouteRouteChildren = {
  AppComplaintsIndexRoute: AppComplaintsIndexRoute,
}

const AppComplaintsRouteRouteWithChildren =
  AppComplaintsRouteRoute._addFileChildren(AppComplaintsRouteRouteChildren)

interface AppCskhRouteRouteChildren {
  AppCskhOrderIdRoute: typeof AppCskhOrderIdRoute
  AppCskhIndexRoute: typeof AppCskhIndexRoute
}

const AppCskhRouteRouteChildren: AppCskhRouteRouteChildren = {
  AppCskhOrderIdRoute: AppCskhOrderIdRoute,
  AppCskhIndexRoute: AppCskhIndexRoute,
}

const AppCskhRouteRouteWithChildren = AppCskhRouteRoute._addFileChildren(
  AppCskhRouteRouteChildren,
)

interface AppCustomerVoiceRouteRouteChildren {
  AppCustomerVoiceIndexRoute: typeof AppCustomerVoiceIndexRoute
}

const AppCustomerVoiceRouteRouteChildren: AppCustomerVoiceRouteRouteChildren = {
  AppCustomerVoiceIndexRoute: AppCustomerVoiceIndexRoute,
}

const AppCustomerVoiceRouteRouteWithChildren =
  AppCustomerVoiceRouteRoute._addFileChildren(
    AppCustomerVoiceRouteRouteChildren,
  )

interface AppCustomersRouteRouteChildren {
  AppCustomersCustomerIdRoute: typeof AppCustomersCustomerIdRoute
  AppCustomersOrderHistoryRoute: typeof AppCustomersOrderHistoryRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
}

const AppCustomersRouteRouteChildren: AppCustomersRouteRouteChildren = {
  AppCustomersCustomerIdRoute: AppCustomersCustomerIdRoute,
  AppCustomersOrderHistoryRoute: AppCustomersOrderHistoryRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
}

const AppCustomersRouteRouteWithChildren =
  AppCustomersRouteRoute._addFileChildren(AppCustomersRouteRouteChildren)

interface AppDirectorBoardRouteRouteChildren {
  AppDirectorBoardIndexRoute: typeof AppDirectorBoardIndexRoute
}

const AppDirectorBoardRouteRouteChildren: AppDirectorBoardRouteRouteChildren = {
  AppDirectorBoardIndexRoute: AppDirectorBoardIndexRoute,
}

const AppDirectorBoardRouteRouteWithChildren =
  AppDirectorBoardRouteRoute._addFileChildren(
    AppDirectorBoardRouteRouteChildren,
  )

interface AppEkipConfigRouteRouteChildren {
  AppEkipConfigIndexRoute: typeof AppEkipConfigIndexRoute
}

const AppEkipConfigRouteRouteChildren: AppEkipConfigRouteRouteChildren = {
  AppEkipConfigIndexRoute: AppEkipConfigIndexRoute,
}

const AppEkipConfigRouteRouteWithChildren =
  AppEkipConfigRouteRoute._addFileChildren(AppEkipConfigRouteRouteChildren)

interface AppEkipPoolRouteRouteChildren {
  AppEkipPoolIndexRoute: typeof AppEkipPoolIndexRoute
}

const AppEkipPoolRouteRouteChildren: AppEkipPoolRouteRouteChildren = {
  AppEkipPoolIndexRoute: AppEkipPoolIndexRoute,
}

const AppEkipPoolRouteRouteWithChildren =
  AppEkipPoolRouteRoute._addFileChildren(AppEkipPoolRouteRouteChildren)

interface AppEkipShiftsRouteRouteChildren {
  AppEkipShiftsIndexRoute: typeof AppEkipShiftsIndexRoute
}

const AppEkipShiftsRouteRouteChildren: AppEkipShiftsRouteRouteChildren = {
  AppEkipShiftsIndexRoute: AppEkipShiftsIndexRoute,
}

const AppEkipShiftsRouteRouteWithChildren =
  AppEkipShiftsRouteRoute._addFileChildren(AppEkipShiftsRouteRouteChildren)

interface AppEquipmentOverdueRouteRouteChildren {
  AppEquipmentOverdueIndexRoute: typeof AppEquipmentOverdueIndexRoute
}

const AppEquipmentOverdueRouteRouteChildren: AppEquipmentOverdueRouteRouteChildren =
  {
    AppEquipmentOverdueIndexRoute: AppEquipmentOverdueIndexRoute,
  }

const AppEquipmentOverdueRouteRouteWithChildren =
  AppEquipmentOverdueRouteRoute._addFileChildren(
    AppEquipmentOverdueRouteRouteChildren,
  )

interface AppExpensesRouteRouteChildren {
  AppExpensesIndexRoute: typeof AppExpensesIndexRoute
}

const AppExpensesRouteRouteChildren: AppExpensesRouteRouteChildren = {
  AppExpensesIndexRoute: AppExpensesIndexRoute,
}

const AppExpensesRouteRouteWithChildren =
  AppExpensesRouteRoute._addFileChildren(AppExpensesRouteRouteChildren)

interface AppGeneralSettingsRouteRouteChildren {
  AppGeneralSettingsIndexRoute: typeof AppGeneralSettingsIndexRoute
}

const AppGeneralSettingsRouteRouteChildren: AppGeneralSettingsRouteRouteChildren =
  {
    AppGeneralSettingsIndexRoute: AppGeneralSettingsIndexRoute,
  }

const AppGeneralSettingsRouteRouteWithChildren =
  AppGeneralSettingsRouteRoute._addFileChildren(
    AppGeneralSettingsRouteRouteChildren,
  )

interface AppHalfDaySlotsRouteRouteChildren {
  AppHalfDaySlotsIndexRoute: typeof AppHalfDaySlotsIndexRoute
}

const AppHalfDaySlotsRouteRouteChildren: AppHalfDaySlotsRouteRouteChildren = {
  AppHalfDaySlotsIndexRoute: AppHalfDaySlotsIndexRoute,
}

const AppHalfDaySlotsRouteRouteWithChildren =
  AppHalfDaySlotsRouteRoute._addFileChildren(AppHalfDaySlotsRouteRouteChildren)

interface AppKhoRouteRouteChildren {
  AppKhoIndexRoute: typeof AppKhoIndexRoute
}

const AppKhoRouteRouteChildren: AppKhoRouteRouteChildren = {
  AppKhoIndexRoute: AppKhoIndexRoute,
}

const AppKhoRouteRouteWithChildren = AppKhoRouteRoute._addFileChildren(
  AppKhoRouteRouteChildren,
)

interface AppKhoYTuongRouteRouteChildren {
  AppKhoYTuongIndexRoute: typeof AppKhoYTuongIndexRoute
}

const AppKhoYTuongRouteRouteChildren: AppKhoYTuongRouteRouteChildren = {
  AppKhoYTuongIndexRoute: AppKhoYTuongIndexRoute,
}

const AppKhoYTuongRouteRouteWithChildren =
  AppKhoYTuongRouteRoute._addFileChildren(AppKhoYTuongRouteRouteChildren)

interface AppLetanShiftsRouteRouteChildren {
  AppLetanShiftsIndexRoute: typeof AppLetanShiftsIndexRoute
}

const AppLetanShiftsRouteRouteChildren: AppLetanShiftsRouteRouteChildren = {
  AppLetanShiftsIndexRoute: AppLetanShiftsIndexRoute,
}

const AppLetanShiftsRouteRouteWithChildren =
  AppLetanShiftsRouteRoute._addFileChildren(AppLetanShiftsRouteRouteChildren)

interface AppMarketingRouteRouteChildren {
  AppMarketingIndexRoute: typeof AppMarketingIndexRoute
}

const AppMarketingRouteRouteChildren: AppMarketingRouteRouteChildren = {
  AppMarketingIndexRoute: AppMarketingIndexRoute,
}

const AppMarketingRouteRouteWithChildren =
  AppMarketingRouteRoute._addFileChildren(AppMarketingRouteRouteChildren)

interface AppMgmtPerformanceRouteRouteChildren {
  AppMgmtPerformanceIndexRoute: typeof AppMgmtPerformanceIndexRoute
}

const AppMgmtPerformanceRouteRouteChildren: AppMgmtPerformanceRouteRouteChildren =
  {
    AppMgmtPerformanceIndexRoute: AppMgmtPerformanceIndexRoute,
  }

const AppMgmtPerformanceRouteRouteWithChildren =
  AppMgmtPerformanceRouteRoute._addFileChildren(
    AppMgmtPerformanceRouteRouteChildren,
  )

interface AppObligationsRouteRouteChildren {
  AppObligationsIndexRoute: typeof AppObligationsIndexRoute
}

const AppObligationsRouteRouteChildren: AppObligationsRouteRouteChildren = {
  AppObligationsIndexRoute: AppObligationsIndexRoute,
}

const AppObligationsRouteRouteWithChildren =
  AppObligationsRouteRoute._addFileChildren(AppObligationsRouteRouteChildren)

interface AppOrdersRouteRouteChildren {
  AppOrdersOrderIdRoute: typeof AppOrdersOrderIdRoute
  AppOrdersNewRoute: typeof AppOrdersNewRoute
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute
}

const AppOrdersRouteRouteChildren: AppOrdersRouteRouteChildren = {
  AppOrdersOrderIdRoute: AppOrdersOrderIdRoute,
  AppOrdersNewRoute: AppOrdersNewRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
}

const AppOrdersRouteRouteWithChildren = AppOrdersRouteRoute._addFileChildren(
  AppOrdersRouteRouteChildren,
)

interface AppPayrollRouteRouteChildren {
  AppPayrollIndexRoute: typeof AppPayrollIndexRoute
}

const AppPayrollRouteRouteChildren: AppPayrollRouteRouteChildren = {
  AppPayrollIndexRoute: AppPayrollIndexRoute,
}

const AppPayrollRouteRouteWithChildren = AppPayrollRouteRoute._addFileChildren(
  AppPayrollRouteRouteChildren,
)

interface AppPerformanceRouteRouteChildren {
  AppPerformanceAdminRoute: typeof AppPerformanceAdminRoute
  AppPerformanceReviewRoute: typeof AppPerformanceReviewRoute
  AppPerformanceIndexRoute: typeof AppPerformanceIndexRoute
}

const AppPerformanceRouteRouteChildren: AppPerformanceRouteRouteChildren = {
  AppPerformanceAdminRoute: AppPerformanceAdminRoute,
  AppPerformanceReviewRoute: AppPerformanceReviewRoute,
  AppPerformanceIndexRoute: AppPerformanceIndexRoute,
}

const AppPerformanceRouteRouteWithChildren =
  AppPerformanceRouteRoute._addFileChildren(AppPerformanceRouteRouteChildren)

interface AppPhotoWorkRouteRouteChildren {
  AppPhotoWorkIndexRoute: typeof AppPhotoWorkIndexRoute
}

const AppPhotoWorkRouteRouteChildren: AppPhotoWorkRouteRouteChildren = {
  AppPhotoWorkIndexRoute: AppPhotoWorkIndexRoute,
}

const AppPhotoWorkRouteRouteWithChildren =
  AppPhotoWorkRouteRoute._addFileChildren(AppPhotoWorkRouteRouteChildren)

interface AppPrintOpsRouteRouteChildren {
  AppPrintOpsIndexRoute: typeof AppPrintOpsIndexRoute
}

const AppPrintOpsRouteRouteChildren: AppPrintOpsRouteRouteChildren = {
  AppPrintOpsIndexRoute: AppPrintOpsIndexRoute,
}

const AppPrintOpsRouteRouteWithChildren =
  AppPrintOpsRouteRoute._addFileChildren(AppPrintOpsRouteRouteChildren)

interface AppPromosRouteRouteChildren {
  AppPromosPromoIdRoute: typeof AppPromosPromoIdRoute
  AppPromosIndexRoute: typeof AppPromosIndexRoute
}

const AppPromosRouteRouteChildren: AppPromosRouteRouteChildren = {
  AppPromosPromoIdRoute: AppPromosPromoIdRoute,
  AppPromosIndexRoute: AppPromosIndexRoute,
}

const AppPromosRouteRouteWithChildren = AppPromosRouteRoute._addFileChildren(
  AppPromosRouteRouteChildren,
)

interface AppQcBoardRouteRouteChildren {
  AppQcBoardIndexRoute: typeof AppQcBoardIndexRoute
}

const AppQcBoardRouteRouteChildren: AppQcBoardRouteRouteChildren = {
  AppQcBoardIndexRoute: AppQcBoardIndexRoute,
}

const AppQcBoardRouteRouteWithChildren = AppQcBoardRouteRoute._addFileChildren(
  AppQcBoardRouteRouteChildren,
)

interface AppQcDeskRouteRouteChildren {
  AppQcDeskAnhTheRoute: typeof AppQcDeskAnhTheRoute
  AppQcDeskHanhTrinhRoute: typeof AppQcDeskHanhTrinhRoute
  AppQcDeskHauKiemRoute: typeof AppQcDeskHauKiemRoute
  AppQcDeskIndexRoute: typeof AppQcDeskIndexRoute
}

const AppQcDeskRouteRouteChildren: AppQcDeskRouteRouteChildren = {
  AppQcDeskAnhTheRoute: AppQcDeskAnhTheRoute,
  AppQcDeskHanhTrinhRoute: AppQcDeskHanhTrinhRoute,
  AppQcDeskHauKiemRoute: AppQcDeskHauKiemRoute,
  AppQcDeskIndexRoute: AppQcDeskIndexRoute,
}

const AppQcDeskRouteRouteWithChildren = AppQcDeskRouteRoute._addFileChildren(
  AppQcDeskRouteRouteChildren,
)

interface AppQcOverviewRouteRouteChildren {
  AppQcOverviewIndexRoute: typeof AppQcOverviewIndexRoute
  AppQcOverviewQcStaffIdRoute: typeof AppQcOverviewQcStaffIdRoute
}

const AppQcOverviewRouteRouteChildren: AppQcOverviewRouteRouteChildren = {
  AppQcOverviewIndexRoute: AppQcOverviewIndexRoute,
  AppQcOverviewQcStaffIdRoute: AppQcOverviewQcStaffIdRoute,
}

const AppQcOverviewRouteRouteWithChildren =
  AppQcOverviewRouteRoute._addFileChildren(AppQcOverviewRouteRouteChildren)

interface AppQualityRouteRouteChildren {
  AppQualityIndexRoute: typeof AppQualityIndexRoute
}

const AppQualityRouteRouteChildren: AppQualityRouteRouteChildren = {
  AppQualityIndexRoute: AppQualityIndexRoute,
}

const AppQualityRouteRouteWithChildren = AppQualityRouteRoute._addFileChildren(
  AppQualityRouteRouteChildren,
)

interface AppRankingsRouteRouteChildren {
  AppRankingsIndexRoute: typeof AppRankingsIndexRoute
}

const AppRankingsRouteRouteChildren: AppRankingsRouteRouteChildren = {
  AppRankingsIndexRoute: AppRankingsIndexRoute,
}

const AppRankingsRouteRouteWithChildren =
  AppRankingsRouteRoute._addFileChildren(AppRankingsRouteRouteChildren)

interface AppReportsRouteRouteChildren {
  AppReportsIndexRoute: typeof AppReportsIndexRoute
}

const AppReportsRouteRouteChildren: AppReportsRouteRouteChildren = {
  AppReportsIndexRoute: AppReportsIndexRoute,
}

const AppReportsRouteRouteWithChildren = AppReportsRouteRoute._addFileChildren(
  AppReportsRouteRouteChildren,
)

interface AppRetouchRouteRouteChildren {
  AppRetouchIndexRoute: typeof AppRetouchIndexRoute
  AppRetouchOrdersOrderIdRoute: typeof AppRetouchOrdersOrderIdRoute
}

const AppRetouchRouteRouteChildren: AppRetouchRouteRouteChildren = {
  AppRetouchIndexRoute: AppRetouchIndexRoute,
  AppRetouchOrdersOrderIdRoute: AppRetouchOrdersOrderIdRoute,
}

const AppRetouchRouteRouteWithChildren = AppRetouchRouteRoute._addFileChildren(
  AppRetouchRouteRouteChildren,
)

interface AppSalaryAnalyticsRouteRouteChildren {
  AppSalaryAnalyticsStaffIdRoute: typeof AppSalaryAnalyticsStaffIdRoute
  AppSalaryAnalyticsIndexRoute: typeof AppSalaryAnalyticsIndexRoute
}

const AppSalaryAnalyticsRouteRouteChildren: AppSalaryAnalyticsRouteRouteChildren =
  {
    AppSalaryAnalyticsStaffIdRoute: AppSalaryAnalyticsStaffIdRoute,
    AppSalaryAnalyticsIndexRoute: AppSalaryAnalyticsIndexRoute,
  }

const AppSalaryAnalyticsRouteRouteWithChildren =
  AppSalaryAnalyticsRouteRoute._addFileChildren(
    AppSalaryAnalyticsRouteRouteChildren,
  )

interface AppSalaryRulesRouteRouteChildren {
  AppSalaryRulesIndexRoute: typeof AppSalaryRulesIndexRoute
}

const AppSalaryRulesRouteRouteChildren: AppSalaryRulesRouteRouteChildren = {
  AppSalaryRulesIndexRoute: AppSalaryRulesIndexRoute,
}

const AppSalaryRulesRouteRouteWithChildren =
  AppSalaryRulesRouteRoute._addFileChildren(AppSalaryRulesRouteRouteChildren)

interface AppSalaryRulesV2RouteRouteChildren {
  AppSalaryRulesV2IndexRoute: typeof AppSalaryRulesV2IndexRoute
}

const AppSalaryRulesV2RouteRouteChildren: AppSalaryRulesV2RouteRouteChildren = {
  AppSalaryRulesV2IndexRoute: AppSalaryRulesV2IndexRoute,
}

const AppSalaryRulesV2RouteRouteWithChildren =
  AppSalaryRulesV2RouteRoute._addFileChildren(
    AppSalaryRulesV2RouteRouteChildren,
  )

interface AppSalesTeamRouteRouteChildren {
  AppSalesTeamIndexRoute: typeof AppSalesTeamIndexRoute
}

const AppSalesTeamRouteRouteChildren: AppSalesTeamRouteRouteChildren = {
  AppSalesTeamIndexRoute: AppSalesTeamIndexRoute,
}

const AppSalesTeamRouteRouteWithChildren =
  AppSalesTeamRouteRoute._addFileChildren(AppSalesTeamRouteRouteChildren)

interface AppScheduleRouteRouteChildren {
  AppScheduleIndexRoute: typeof AppScheduleIndexRoute
}

const AppScheduleRouteRouteChildren: AppScheduleRouteRouteChildren = {
  AppScheduleIndexRoute: AppScheduleIndexRoute,
}

const AppScheduleRouteRouteWithChildren =
  AppScheduleRouteRoute._addFileChildren(AppScheduleRouteRouteChildren)

interface AppSpotChecksRouteRouteChildren {
  AppSpotChecksIndexRoute: typeof AppSpotChecksIndexRoute
}

const AppSpotChecksRouteRouteChildren: AppSpotChecksRouteRouteChildren = {
  AppSpotChecksIndexRoute: AppSpotChecksIndexRoute,
}

const AppSpotChecksRouteRouteWithChildren =
  AppSpotChecksRouteRoute._addFileChildren(AppSpotChecksRouteRouteChildren)

interface AppSuggestionsRouteRouteChildren {
  AppSuggestionsIndexRoute: typeof AppSuggestionsIndexRoute
}

const AppSuggestionsRouteRouteChildren: AppSuggestionsRouteRouteChildren = {
  AppSuggestionsIndexRoute: AppSuggestionsIndexRoute,
}

const AppSuggestionsRouteRouteWithChildren =
  AppSuggestionsRouteRoute._addFileChildren(AppSuggestionsRouteRouteChildren)

interface AppViecCanXemRouteRouteChildren {
  AppViecCanXemIndexRoute: typeof AppViecCanXemIndexRoute
}

const AppViecCanXemRouteRouteChildren: AppViecCanXemRouteRouteChildren = {
  AppViecCanXemIndexRoute: AppViecCanXemIndexRoute,
}

const AppViecCanXemRouteRouteWithChildren =
  AppViecCanXemRouteRoute._addFileChildren(AppViecCanXemRouteRouteChildren)

interface AppZaloRouteRouteChildren {
  AppZaloIndexRoute: typeof AppZaloIndexRoute
}

const AppZaloRouteRouteChildren: AppZaloRouteRouteChildren = {
  AppZaloIndexRoute: AppZaloIndexRoute,
}

const AppZaloRouteRouteWithChildren = AppZaloRouteRoute._addFileChildren(
  AppZaloRouteRouteChildren,
)

interface AppGalleryOrdersOrderIdRouteRouteChildren {
  AppGalleryOrdersOrderIdFixBoardRoute: typeof AppGalleryOrdersOrderIdFixBoardRoute
  AppGalleryOrdersOrderIdIndexRoute: typeof AppGalleryOrdersOrderIdIndexRoute
  AppGalleryOrdersOrderIdComposeAlbumIdRoute: typeof AppGalleryOrdersOrderIdComposeAlbumIdRoute
}

const AppGalleryOrdersOrderIdRouteRouteChildren: AppGalleryOrdersOrderIdRouteRouteChildren =
  {
    AppGalleryOrdersOrderIdFixBoardRoute: AppGalleryOrdersOrderIdFixBoardRoute,
    AppGalleryOrdersOrderIdIndexRoute: AppGalleryOrdersOrderIdIndexRoute,
    AppGalleryOrdersOrderIdComposeAlbumIdRoute:
      AppGalleryOrdersOrderIdComposeAlbumIdRoute,
  }

const AppGalleryOrdersOrderIdRouteRouteWithChildren =
  AppGalleryOrdersOrderIdRouteRoute._addFileChildren(
    AppGalleryOrdersOrderIdRouteRouteChildren,
  )

interface AppRouteChildren {
  AppAffiliatesRouteRoute: typeof AppAffiliatesRouteRouteWithChildren
  AppAlbumsRouteRoute: typeof AppAlbumsRouteRouteWithChildren
  AppBranchKpiRouteRoute: typeof AppBranchKpiRouteRouteWithChildren
  AppBranchScoresRouteRoute: typeof AppBranchScoresRouteRouteWithChildren
  AppBranchShiftsRouteRoute: typeof AppBranchShiftsRouteRouteWithChildren
  AppBusinessPlanRouteRoute: typeof AppBusinessPlanRouteRouteWithChildren
  AppCashChainRouteRoute: typeof AppCashChainRouteRouteWithChildren
  AppCashDrawerRouteRoute: typeof AppCashDrawerRouteRouteWithChildren
  AppComplaintsRouteRoute: typeof AppComplaintsRouteRouteWithChildren
  AppConceptGuidesRouteRoute: typeof AppConceptGuidesRouteRoute
  AppCskhRouteRoute: typeof AppCskhRouteRouteWithChildren
  AppCustomerVoiceRouteRoute: typeof AppCustomerVoiceRouteRouteWithChildren
  AppCustomersRouteRoute: typeof AppCustomersRouteRouteWithChildren
  AppDirectorBoardRouteRoute: typeof AppDirectorBoardRouteRouteWithChildren
  AppEkipConfigRouteRoute: typeof AppEkipConfigRouteRouteWithChildren
  AppEkipPoolRouteRoute: typeof AppEkipPoolRouteRouteWithChildren
  AppEkipShiftsRouteRoute: typeof AppEkipShiftsRouteRouteWithChildren
  AppEquipmentOverdueRouteRoute: typeof AppEquipmentOverdueRouteRouteWithChildren
  AppExpensesRouteRoute: typeof AppExpensesRouteRouteWithChildren
  AppGeneralSettingsRouteRoute: typeof AppGeneralSettingsRouteRouteWithChildren
  AppHalfDaySlotsRouteRoute: typeof AppHalfDaySlotsRouteRouteWithChildren
  AppKhoRouteRoute: typeof AppKhoRouteRouteWithChildren
  AppKhoYTuongRouteRoute: typeof AppKhoYTuongRouteRouteWithChildren
  AppLetanShiftsRouteRoute: typeof AppLetanShiftsRouteRouteWithChildren
  AppMarketingRouteRoute: typeof AppMarketingRouteRouteWithChildren
  AppMgmtPerformanceRouteRoute: typeof AppMgmtPerformanceRouteRouteWithChildren
  AppObligationsRouteRoute: typeof AppObligationsRouteRouteWithChildren
  AppOrdersRouteRoute: typeof AppOrdersRouteRouteWithChildren
  AppPayrollRouteRoute: typeof AppPayrollRouteRouteWithChildren
  AppPerformanceRouteRoute: typeof AppPerformanceRouteRouteWithChildren
  AppPhotoWorkRouteRoute: typeof AppPhotoWorkRouteRouteWithChildren
  AppPrintOpsRouteRoute: typeof AppPrintOpsRouteRouteWithChildren
  AppPromosRouteRoute: typeof AppPromosRouteRouteWithChildren
  AppQcBoardRouteRoute: typeof AppQcBoardRouteRouteWithChildren
  AppQcDeskRouteRoute: typeof AppQcDeskRouteRouteWithChildren
  AppQcOverviewRouteRoute: typeof AppQcOverviewRouteRouteWithChildren
  AppQualityRouteRoute: typeof AppQualityRouteRouteWithChildren
  AppRankingsRouteRoute: typeof AppRankingsRouteRouteWithChildren
  AppReportsRouteRoute: typeof AppReportsRouteRouteWithChildren
  AppRetouchRouteRoute: typeof AppRetouchRouteRouteWithChildren
  AppSalaryAnalyticsRouteRoute: typeof AppSalaryAnalyticsRouteRouteWithChildren
  AppSalaryRulesRouteRoute: typeof AppSalaryRulesRouteRouteWithChildren
  AppSalaryRulesV2RouteRoute: typeof AppSalaryRulesV2RouteRouteWithChildren
  AppSalesTeamRouteRoute: typeof AppSalesTeamRouteRouteWithChildren
  AppScheduleRouteRoute: typeof AppScheduleRouteRouteWithChildren
  AppSpotChecksRouteRoute: typeof AppSpotChecksRouteRouteWithChildren
  AppSuggestionsRouteRoute: typeof AppSuggestionsRouteRouteWithChildren
  AppViecCanXemRouteRoute: typeof AppViecCanXemRouteRouteWithChildren
  AppZaloRouteRoute: typeof AppZaloRouteRouteWithChildren
  AppComposeBackdropsRoute: typeof AppComposeBackdropsRoute
  AppCostumesRoute: typeof AppCostumesRoute
  AppCustomerChatsRoute: typeof AppCustomerChatsRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDispatchBoardRoute: typeof AppDispatchBoardRoute
  AppDispatchPointsRoute: typeof AppDispatchPointsRoute
  AppDispatchSettingsRoute: typeof AppDispatchSettingsRoute
  AppExpenseClaimsRoute: typeof AppExpenseClaimsRoute
  AppFraudBoardRoute: typeof AppFraudBoardRoute
  AppHomeRoute: typeof AppHomeRoute
  AppHunchRoomRoute: typeof AppHunchRoomRoute
  AppIntegrationsRoute: typeof AppIntegrationsRoute
  AppKenhNhanSuRoute: typeof AppKenhNhanSuRoute
  AppMeRoute: typeof AppMeRoute
  AppMedalsRoute: typeof AppMedalsRoute
  AppMyDispatchRoute: typeof AppMyDispatchRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppPaymentsRoute: typeof AppPaymentsRoute
  AppPrintOpsReportRoute: typeof AppPrintOpsReportRoute
  AppPrinterInvoicesRoute: typeof AppPrinterInvoicesRoute
  AppProductsRoute: typeof AppProductsRoute
  AppQuoteApprovalsRoute: typeof AppQuoteApprovalsRoute
  AppRegulationsRoute: typeof AppRegulationsRoute
  AppRetouchDispatchSettingsRoute: typeof AppRetouchDispatchSettingsRoute
  AppSealedInboxRoute: typeof AppSealedInboxRoute
  AppSealedInboxReaderRoute: typeof AppSealedInboxReaderRoute
  AppSetBoardRoute: typeof AppSetBoardRoute
  AppStaffRoute: typeof AppStaffRoute
  AppStaffCheckinsRoute: typeof AppStaffCheckinsRoute
  AppStaffProductivityRoute: typeof AppStaffProductivityRoute
  AppStoreBoardRoute: typeof AppStoreBoardRoute
  AppTraDoRoute: typeof AppTraDoRoute
  AppMuonTraDoLazyRoute: typeof AppMuonTraDoLazyRoute
  AppMeCollectionRoute: typeof AppMeCollectionRoute
  AppMeJourneyRoute: typeof AppMeJourneyRoute
  AppQuotePrintOrderIdRoute: typeof AppQuotePrintOrderIdRoute
  AppSealedInboxReaderIdRoute: typeof AppSealedInboxReaderIdRoute
  AppSealedInboxIdRoute: typeof AppSealedInboxIdRoute
  AppGalleryOrdersOrderIdRouteRoute: typeof AppGalleryOrdersOrderIdRouteRouteWithChildren
  AppFraudBoardBangChungIdRoute: typeof AppFraudBoardBangChungIdRoute
  AppFraudBoardCapNguoiKeyRoute: typeof AppFraudBoardCapNguoiKeyRoute
  AppFraudBoardCapSoKeyRoute: typeof AppFraudBoardCapSoKeyRoute
  AppFraudBoardKhachBiMatIdRoute: typeof AppFraudBoardKhachBiMatIdRoute
  AppGalleryAlbumsContainerIdRoute: typeof AppGalleryAlbumsContainerIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAffiliatesRouteRoute: AppAffiliatesRouteRouteWithChildren,
  AppAlbumsRouteRoute: AppAlbumsRouteRouteWithChildren,
  AppBranchKpiRouteRoute: AppBranchKpiRouteRouteWithChildren,
  AppBranchScoresRouteRoute: AppBranchScoresRouteRouteWithChildren,
  AppBranchShiftsRouteRoute: AppBranchShiftsRouteRouteWithChildren,
  AppBusinessPlanRouteRoute: AppBusinessPlanRouteRouteWithChildren,
  AppCashChainRouteRoute: AppCashChainRouteRouteWithChildren,
  AppCashDrawerRouteRoute: AppCashDrawerRouteRouteWithChildren,
  AppComplaintsRouteRoute: AppComplaintsRouteRouteWithChildren,
  AppConceptGuidesRouteRoute: AppConceptGuidesRouteRoute,
  AppCskhRouteRoute: AppCskhRouteRouteWithChildren,
  AppCustomerVoiceRouteRoute: AppCustomerVoiceRouteRouteWithChildren,
  AppCustomersRouteRoute: AppCustomersRouteRouteWithChildren,
  AppDirectorBoardRouteRoute: AppDirectorBoardRouteRouteWithChildren,
  AppEkipConfigRouteRoute: AppEkipConfigRouteRouteWithChildren,
  AppEkipPoolRouteRoute: AppEkipPoolRouteRouteWithChildren,
  AppEkipShiftsRouteRoute: AppEkipShiftsRouteRouteWithChildren,
  AppEquipmentOverdueRouteRoute: AppEquipmentOverdueRouteRouteWithChildren,
  AppExpensesRouteRoute: AppExpensesRouteRouteWithChildren,
  AppGeneralSettingsRouteRoute: AppGeneralSettingsRouteRouteWithChildren,
  AppHalfDaySlotsRouteRoute: AppHalfDaySlotsRouteRouteWithChildren,
  AppKhoRouteRoute: AppKhoRouteRouteWithChildren,
  AppKhoYTuongRouteRoute: AppKhoYTuongRouteRouteWithChildren,
  AppLetanShiftsRouteRoute: AppLetanShiftsRouteRouteWithChildren,
  AppMarketingRouteRoute: AppMarketingRouteRouteWithChildren,
  AppMgmtPerformanceRouteRoute: AppMgmtPerformanceRouteRouteWithChildren,
  AppObligationsRouteRoute: AppObligationsRouteRouteWithChildren,
  AppOrdersRouteRoute: AppOrdersRouteRouteWithChildren,
  AppPayrollRouteRoute: AppPayrollRouteRouteWithChildren,
  AppPerformanceRouteRoute: AppPerformanceRouteRouteWithChildren,
  AppPhotoWorkRouteRoute: AppPhotoWorkRouteRouteWithChildren,
  AppPrintOpsRouteRoute: AppPrintOpsRouteRouteWithChildren,
  AppPromosRouteRoute: AppPromosRouteRouteWithChildren,
  AppQcBoardRouteRoute: AppQcBoardRouteRouteWithChildren,
  AppQcDeskRouteRoute: AppQcDeskRouteRouteWithChildren,
  AppQcOverviewRouteRoute: AppQcOverviewRouteRouteWithChildren,
  AppQualityRouteRoute: AppQualityRouteRouteWithChildren,
  AppRankingsRouteRoute: AppRankingsRouteRouteWithChildren,
  AppReportsRouteRoute: AppReportsRouteRouteWithChildren,
  AppRetouchRouteRoute: AppRetouchRouteRouteWithChildren,
  AppSalaryAnalyticsRouteRoute: AppSalaryAnalyticsRouteRouteWithChildren,
  AppSalaryRulesRouteRoute: AppSalaryRulesRouteRouteWithChildren,
  AppSalaryRulesV2RouteRoute: AppSalaryRulesV2RouteRouteWithChildren,
  AppSalesTeamRouteRoute: AppSalesTeamRouteRouteWithChildren,
  AppScheduleRouteRoute: AppScheduleRouteRouteWithChildren,
  AppSpotChecksRouteRoute: AppSpotChecksRouteRouteWithChildren,
  AppSuggestionsRouteRoute: AppSuggestionsRouteRouteWithChildren,
  AppViecCanXemRouteRoute: AppViecCanXemRouteRouteWithChildren,
  AppZaloRouteRoute: AppZaloRouteRouteWithChildren,
  AppComposeBackdropsRoute: AppComposeBackdropsRoute,
  AppCostumesRoute: AppCostumesRoute,
  AppCustomerChatsRoute: AppCustomerChatsRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDispatchBoardRoute: AppDispatchBoardRoute,
  AppDispatchPointsRoute: AppDispatchPointsRoute,
  AppDispatchSettingsRoute: AppDispatchSettingsRoute,
  AppExpenseClaimsRoute: AppExpenseClaimsRoute,
  AppFraudBoardRoute: AppFraudBoardRoute,
  AppHomeRoute: AppHomeRoute,
  AppHunchRoomRoute: AppHunchRoomRoute,
  AppIntegrationsRoute: AppIntegrationsRoute,
  AppKenhNhanSuRoute: AppKenhNhanSuRoute,
  AppMeRoute: AppMeRoute,
  AppMedalsRoute: AppMedalsRoute,
  AppMyDispatchRoute: AppMyDispatchRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppPaymentsRoute: AppPaymentsRoute,
  AppPrintOpsReportRoute: AppPrintOpsReportRoute,
  AppPrinterInvoicesRoute: AppPrinterInvoicesRoute,
  AppProductsRoute: AppProductsRoute,
  AppQuoteApprovalsRoute: AppQuoteApprovalsRoute,
  AppRegulationsRoute: AppRegulationsRoute,
  AppRetouchDispatchSettingsRoute: AppRetouchDispatchSettingsRoute,
  AppSealedInboxRoute: AppSealedInboxRoute,
  AppSealedInboxReaderRoute: AppSealedInboxReaderRoute,
  AppSetBoardRoute: AppSetBoardRoute,
  AppStaffRoute: AppStaffRoute,
  AppStaffCheckinsRoute: AppStaffCheckinsRoute,
  AppStaffProductivityRoute: AppStaffProductivityRoute,
  AppStoreBoardRoute: AppStoreBoardRoute,
  AppTraDoRoute: AppTraDoRoute,
  AppMuonTraDoLazyRoute: AppMuonTraDoLazyRoute,
  AppMeCollectionRoute: AppMeCollectionRoute,
  AppMeJourneyRoute: AppMeJourneyRoute,
  AppQuotePrintOrderIdRoute: AppQuotePrintOrderIdRoute,
  AppSealedInboxReaderIdRoute: AppSealedInboxReaderIdRoute,
  AppSealedInboxIdRoute: AppSealedInboxIdRoute,
  AppGalleryOrdersOrderIdRouteRoute:
    AppGalleryOrdersOrderIdRouteRouteWithChildren,
  AppFraudBoardBangChungIdRoute: AppFraudBoardBangChungIdRoute,
  AppFraudBoardCapNguoiKeyRoute: AppFraudBoardCapNguoiKeyRoute,
  AppFraudBoardCapSoKeyRoute: AppFraudBoardCapSoKeyRoute,
  AppFraudBoardKhachBiMatIdRoute: AppFraudBoardKhachBiMatIdRoute,
  AppGalleryAlbumsContainerIdRoute: AppGalleryAlbumsContainerIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface DevRouteChildren {
  DevAttentionRoute: typeof DevAttentionRoute
  DevComponentsRoute: typeof DevComponentsRoute
  DevCskhPreviewRoute: typeof DevCskhPreviewRoute
  DevEkipProofRoute: typeof DevEkipProofRoute
  DevFaceProbeRoute: typeof DevFaceProbeRoute
  DevKpiScopeRoute: typeof DevKpiScopeRoute
  DevSalaryDetailRoute: typeof DevSalaryDetailRoute
}

const DevRouteChildren: DevRouteChildren = {
  DevAttentionRoute: DevAttentionRoute,
  DevComponentsRoute: DevComponentsRoute,
  DevCskhPreviewRoute: DevCskhPreviewRoute,
  DevEkipProofRoute: DevEkipProofRoute,
  DevFaceProbeRoute: DevFaceProbeRoute,
  DevKpiScopeRoute: DevKpiScopeRoute,
  DevSalaryDetailRoute: DevSalaryDetailRoute,
}

const DevRouteWithChildren = DevRoute._addFileChildren(DevRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R403Route: R403Route,
  R404Route: R404Route,
  AppRoute: AppRouteWithChildren,
  DevRoute: DevRouteWithChildren,
  LoginRoute: LoginRoute,
  AlbumTokenRoute: AlbumTokenRoute,
  AnhInTokenRoute: AnhInTokenRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  BookingBranchCodeRoute: BookingBranchCodeRoute,
  BookingMeRoute: BookingMeRoute,
  ChonAnhTokenRoute: ChonAnhTokenRoute,
  BookingIndexRoute: BookingIndexRoute,
  GalleryShareTokenRoute: GalleryShareTokenRoute,
  BookingMeOrdersOrderIdAlbumRoute: BookingMeOrdersOrderIdAlbumRoute,
  BookingMeOrdersOrderIdGalleryRoute: BookingMeOrdersOrderIdGalleryRoute,
  BookingMeOrdersOrderIdOriginalAlbumRoute:
    BookingMeOrdersOrderIdOriginalAlbumRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
